import activity from '../components/activity.js';
import addAndSubtract from '../components/add-and-subtract.js';
import addCircle from '../components/add-circle.js';
import addRectangle from '../components/add-rectangle.js';
import add from '../components/add.js';
import addressBook from '../components/address-book.js';
import adjustment from '../components/adjustment.js';
import airplayWave from '../components/airplay-wave.js';
import alarmAdd from '../components/alarm-add.js';
import alarmOff from '../components/alarm-off.js';
import alarm from '../components/alarm.js';
import alignTop from '../components/align-top.js';
import alignVertical from '../components/align-vertical.js';
import alpha from '../components/alpha.js';
import analytics from '../components/analytics.js';
import anchor from '../components/anchor.js';
import angry from '../components/angry.js';
import animation1 from '../components/animation-1.js';
import animation from '../components/animation.js';
import anticlockwise from '../components/anticlockwise.js';
import api from '../components/api.js';
import app from '../components/app.js';
import apple from '../components/apple.js';
import application from '../components/application.js';
import architectureHuiStyle from '../components/architecture-hui-style.js';
import archway1 from '../components/archway-1.js';
import archway from '../components/archway.js';
import arrowDownCircle from '../components/arrow-down-circle.js';
import arrowDownRectangle from '../components/arrow-down-rectangle.js';
import arrowDown from '../components/arrow-down.js';
import arrowLeftCircle from '../components/arrow-left-circle.js';
import arrowLeftDownCircle from '../components/arrow-left-down-circle.js';
import arrowLeftDown from '../components/arrow-left-down.js';
import arrowLeftRight1 from '../components/arrow-left-right-1.js';
import arrowLeftRight2 from '../components/arrow-left-right-2.js';
import arrowLeftRight3 from '../components/arrow-left-right-3.js';
import arrowLeftRightCircle from '../components/arrow-left-right-circle.js';
import arrowLeftUpCircle from '../components/arrow-left-up-circle.js';
import arrowLeftUp from '../components/arrow-left-up.js';
import arrowLeft from '../components/arrow-left.js';
import arrowRightCircle from '../components/arrow-right-circle.js';
import arrowRightDownCircle from '../components/arrow-right-down-circle.js';
import arrowRightDown from '../components/arrow-right-down.js';
import arrowRightUpCircle from '../components/arrow-right-up-circle.js';
import arrowRightUp from '../components/arrow-right-up.js';
import arrowRight from '../components/arrow-right.js';
import arrowTriangleDownFilled from '../components/arrow-triangle-down-filled.js';
import arrowTriangleDown from '../components/arrow-triangle-down.js';
import arrowTriangleUpFilled from '../components/arrow-triangle-up-filled.js';
import arrowTriangleUp from '../components/arrow-triangle-up.js';
import arrowUpCircle from '../components/arrow-up-circle.js';
import arrowUpDown1 from '../components/arrow-up-down-1.js';
import arrowUpDown2 from '../components/arrow-up-down-2.js';
import arrowUpDown3 from '../components/arrow-up-down-3.js';
import arrowUpDownCircle from '../components/arrow-up-down-circle.js';
import arrowUp from '../components/arrow-up.js';
import artboard from '../components/artboard.js';
import article from '../components/article.js';
import assignmentChecked from '../components/assignment-checked.js';
import assignmentCode from '../components/assignment-code.js';
import assignmentError from '../components/assignment-error.js';
import assignmentUser from '../components/assignment-user.js';
import assignment from '../components/assignment.js';
import attach from '../components/attach.js';
import attic1 from '../components/attic-1.js';
import attic from '../components/attic.js';
import audio from '../components/audio.js';
import awkward from '../components/awkward.js';
import backtopRectangle from '../components/backtop-rectangle.js';
import backtop from '../components/backtop.js';
import backup from '../components/backup.js';
import backward from '../components/backward.js';
import badLaugh from '../components/bad-laugh.js';
import bambooShoot from '../components/bamboo-shoot.js';
import banana from '../components/banana.js';
import barbecue from '../components/barbecue.js';
import barcode1 from '../components/barcode-1.js';
import barcode from '../components/barcode.js';
import baseStation from '../components/base-station.js';
import batteryAdd from '../components/battery-add.js';
import batteryCharging from '../components/battery-charging.js';
import batteryLow from '../components/battery-low.js';
import battery from '../components/battery.js';
import bean from '../components/bean.js';
import beer from '../components/beer.js';
import beta from '../components/beta.js';
import bifurcate from '../components/bifurcate.js';
import bill from '../components/bill.js';
import blockchain from '../components/blockchain.js';
import bluetooth from '../components/bluetooth.js';
import bone from '../components/bone.js';
import bookOpen from '../components/book-open.js';
import book from '../components/book.js';
import bookmarkAdd from '../components/bookmark-add.js';
import bookmarkChecked from '../components/bookmark-checked.js';
import bookmarkDouble from '../components/bookmark-double.js';
import bookmarkMinus from '../components/bookmark-minus.js';
import bookmark from '../components/bookmark.js';
import braces from '../components/braces.js';
import brackets from '../components/brackets.js';
import bread from '../components/bread.js';
import bridge1 from '../components/bridge-1.js';
import bridge2 from '../components/bridge-2.js';
import bridge3 from '../components/bridge-3.js';
import bridge4 from '../components/bridge-4.js';
import bridge5 from '../components/bridge-5.js';
import bridge6 from '../components/bridge-6.js';
import bridge from '../components/bridge.js';
import brightness1 from '../components/brightness-1.js';
import brightness from '../components/brightness.js';
import broccoli from '../components/broccoli.js';
import browseGallery from '../components/browse-gallery.js';
import browseOff from '../components/browse-off.js';
import browse from '../components/browse.js';
import brush from '../components/brush.js';
import bugReport from '../components/bug-report.js';
import bug from '../components/bug.js';
import building1 from '../components/building-1.js';
import building2 from '../components/building-2.js';
import building3 from '../components/building-3.js';
import building4 from '../components/building-4.js';
import building5 from '../components/building-5.js';
import building from '../components/building.js';
import bulletpoint from '../components/bulletpoint.js';
import button from '../components/button.js';
import cabbage from '../components/cabbage.js';
import cake from '../components/cake.js';
import calculation1 from '../components/calculation-1.js';
import calculation from '../components/calculation.js';
import calculator1 from '../components/calculator-1.js';
import calculator from '../components/calculator.js';
import calendar1 from '../components/calendar-1.js';
import calendar2 from '../components/calendar-2.js';
import calendarEdit from '../components/calendar-edit.js';
import calendarEvent from '../components/calendar-event.js';
import calendar from '../components/calendar.js';
import call1 from '../components/call-1.js';
import callCancel from '../components/call-cancel.js';
import callForwarded from '../components/call-forwarded.js';
import callIncoming from '../components/call-incoming.js';
import callOff from '../components/call-off.js';
import call from '../components/call.js';
import calm1 from '../components/calm-1.js';
import calm from '../components/calm.js';
import camera1 from '../components/camera-1.js';
import camera2 from '../components/camera-2.js';
import cameraOff from '../components/camera-off.js';
import camera from '../components/camera.js';
import candy from '../components/candy.js';
import card from '../components/card.js';
import cardmembership from '../components/cardmembership.js';
import caretDownSmall from '../components/caret-down-small.js';
import caretDown from '../components/caret-down.js';
import caretLeftSmall from '../components/caret-left-small.js';
import caretLeft from '../components/caret-left.js';
import caretRightSmall from '../components/caret-right-small.js';
import caretRight from '../components/caret-right.js';
import caretUpSmall from '../components/caret-up-small.js';
import caretUp from '../components/caret-up.js';
import cartAdd from '../components/cart-add.js';
import cart from '../components/cart.js';
import cast from '../components/cast.js';
import castle1 from '../components/castle-1.js';
import castle2 from '../components/castle-2.js';
import castle3 from '../components/castle-3.js';
import castle4 from '../components/castle-4.js';
import castle5 from '../components/castle-5.js';
import castle6 from '../components/castle-6.js';
import castle7 from '../components/castle-7.js';
import castle from '../components/castle.js';
import cat from '../components/cat.js';
import catalog from '../components/catalog.js';
import cd from '../components/cd.js';
import celsius from '../components/celsius.js';
import centerFocusStrong from '../components/center-focus-strong.js';
import centimeter from '../components/centimeter.js';
import certificate1 from '../components/certificate-1.js';
import certificate from '../components/certificate.js';
import chart3d from '../components/chart-3d.js';
import chartAdd from '../components/chart-add.js';
import chartAnalytics from '../components/chart-analytics.js';
import chartAreaMulti from '../components/chart-area-multi.js';
import chartArea from '../components/chart-area.js';
import chartBar from '../components/chart-bar.js';
import chartBubble from '../components/chart-bubble.js';
import chartColumn from '../components/chart-column.js';
import chartCombo from '../components/chart-combo.js';
import chartLineData1 from '../components/chart-line-data-1.js';
import chartLineData from '../components/chart-line-data.js';
import chartLineMulti from '../components/chart-line-multi.js';
import chartLine from '../components/chart-line.js';
import chartMaximum from '../components/chart-maximum.js';
import chartMedian from '../components/chart-median.js';
import chartMinimum from '../components/chart-minimum.js';
import chartPie from '../components/chart-pie.js';
import chartRadar from '../components/chart-radar.js';
import chartRadial from '../components/chart-radial.js';
import chartRing1 from '../components/chart-ring-1.js';
import chartRing from '../components/chart-ring.js';
import chartScatter from '../components/chart-scatter.js';
import chartStacked from '../components/chart-stacked.js';
import chart from '../components/chart.js';
import chatAdd from '../components/chat-add.js';
import chatBubble1 from '../components/chat-bubble-1.js';
import chatBubbleAdd from '../components/chat-bubble-add.js';
import chatBubbleError from '../components/chat-bubble-error.js';
import chatBubbleHelp from '../components/chat-bubble-help.js';
import chatBubbleHistory from '../components/chat-bubble-history.js';
import chatBubbleLocked from '../components/chat-bubble-locked.js';
import chatBubbleSmile from '../components/chat-bubble-smile.js';
import chatBubble from '../components/chat-bubble.js';
import chatChecked from '../components/chat-checked.js';
import chatClear from '../components/chat-clear.js';
import chatDouble from '../components/chat-double.js';
import chatError from '../components/chat-error.js';
import chatHeart from '../components/chat-heart.js';
import chatMessage from '../components/chat-message.js';
import chatOff from '../components/chat-off.js';
import chatPoll from '../components/chat-poll.js';
import chatSetting from '../components/chat-setting.js';
import chat from '../components/chat.js';
import checkCircleFilled from '../components/check-circle-filled.js';
import checkCircle from '../components/check-circle.js';
import checkDouble from '../components/check-double.js';
import checkRectangleFilled from '../components/check-rectangle-filled.js';
import checkRectangle from '../components/check-rectangle.js';
import check from '../components/check.js';
import cheese from '../components/cheese.js';
import cherry from '../components/cherry.js';
import chevronDownCircle from '../components/chevron-down-circle.js';
import chevronDownDoubleS from '../components/chevron-down-double-s.js';
import chevronDownDouble from '../components/chevron-down-double.js';
import chevronDownRectangle from '../components/chevron-down-rectangle.js';
import chevronDownS from '../components/chevron-down-s.js';
import chevronDown from '../components/chevron-down.js';
import chevronLeftCircle from '../components/chevron-left-circle.js';
import chevronLeftDoubleS from '../components/chevron-left-double-s.js';
import chevronLeftDouble from '../components/chevron-left-double.js';
import chevronLeftRectangle from '../components/chevron-left-rectangle.js';
import chevronLeftS from '../components/chevron-left-s.js';
import chevronLeft from '../components/chevron-left.js';
import chevronRightCircle from '../components/chevron-right-circle.js';
import chevronRightDoubleS from '../components/chevron-right-double-s.js';
import chevronRightDouble from '../components/chevron-right-double.js';
import chevronRightRectangle from '../components/chevron-right-rectangle.js';
import chevronRightS from '../components/chevron-right-s.js';
import chevronRight from '../components/chevron-right.js';
import chevronUpCircle from '../components/chevron-up-circle.js';
import chevronUpDoubleS from '../components/chevron-up-double-s.js';
import chevronUpDouble from '../components/chevron-up-double.js';
import chevronUpRectangle from '../components/chevron-up-rectangle.js';
import chevronUpS from '../components/chevron-up-s.js';
import chevronUp from '../components/chevron-up.js';
import chicken from '../components/chicken.js';
import chili from '../components/chili.js';
import chimney1 from '../components/chimney-1.js';
import chimney2 from '../components/chimney-2.js';
import chimney from '../components/chimney.js';
import chineseCabbage from '../components/chinese-cabbage.js';
import church from '../components/church.js';
import circle from '../components/circle.js';
import city1 from '../components/city-1.js';
import city10 from '../components/city-10.js';
import city11 from '../components/city-11.js';
import city12 from '../components/city-12.js';
import city13 from '../components/city-13.js';
import city14 from '../components/city-14.js';
import city15 from '../components/city-15.js';
import city2 from '../components/city-2.js';
import city3 from '../components/city-3.js';
import city4 from '../components/city-4.js';
import city5 from '../components/city-5.js';
import city6 from '../components/city-6.js';
import city7 from '../components/city-7.js';
import city8 from '../components/city-8.js';
import city9 from '../components/city-9.js';
import cityAncient1 from '../components/city-ancient-1.js';
import cityAncient2 from '../components/city-ancient-2.js';
import cityAncient from '../components/city-ancient.js';
import city from '../components/city.js';
import clearFormatting1 from '../components/clear-formatting-1.js';
import clearFormatting from '../components/clear-formatting.js';
import clear from '../components/clear.js';
import closeCircleFilled from '../components/close-circle-filled.js';
import closeCircle from '../components/close-circle.js';
import closeOctagon from '../components/close-octagon.js';
import closeRectangle from '../components/close-rectangle.js';
import close from '../components/close.js';
import cloudDownload from '../components/cloud-download.js';
import cloudUpload from '../components/cloud-upload.js';
import cloud from '../components/cloud.js';
import cloudyDay from '../components/cloudy-day.js';
import cloudyNightRain from '../components/cloudy-night-rain.js';
import cloudyNight from '../components/cloudy-night.js';
import cloudyRain from '../components/cloudy-rain.js';
import cloudySunny from '../components/cloudy-sunny.js';
import code1 from '../components/code-1.js';
import codeOff from '../components/code-off.js';
import code from '../components/code.js';
import cola from '../components/cola.js';
import collage from '../components/collage.js';
import collection from '../components/collection.js';
import colorInvert from '../components/color-invert.js';
import combination from '../components/combination.js';
import command from '../components/command.js';
import compass1 from '../components/compass-1.js';
import compass from '../components/compass.js';
import componentBreadcrumb from '../components/component-breadcrumb.js';
import componentCheckbox from '../components/component-checkbox.js';
import componentDividerHorizontal from '../components/component-divider-horizontal.js';
import componentDividerVertical from '../components/component-divider-vertical.js';
import componentDropdown from '../components/component-dropdown.js';
import componentGrid from '../components/component-grid.js';
import componentInput from '../components/component-input.js';
import componentLayout from '../components/component-layout.js';
import componentRadio from '../components/component-radio.js';
import componentSpace from '../components/component-space.js';
import componentSteps from '../components/component-steps.js';
import componentSwitch from '../components/component-switch.js';
import constraint from '../components/constraint.js';
import contrast1 from '../components/contrast-1.js';
import contrast from '../components/contrast.js';
import controlPlatform from '../components/control-platform.js';
import cooperate from '../components/cooperate.js';
import coordinateSystem from '../components/coordinate-system.js';
import copy from '../components/copy.js';
import copyright from '../components/copyright.js';
import corn from '../components/corn.js';
import coupon from '../components/coupon.js';
import course from '../components/course.js';
import cpu from '../components/cpu.js';
import crack from '../components/crack.js';
import creditcardAdd from '../components/creditcard-add.js';
import creditcardOff from '../components/creditcard-off.js';
import creditcard from '../components/creditcard.js';
import crookedSmile from '../components/crooked-smile.js';
import cryAndLaugh from '../components/cry-and-laugh.js';
import cryLoudly from '../components/cry-loudly.js';
import css3 from '../components/css3.js';
import cucumber from '../components/cucumber.js';
import currencyExchange from '../components/currency-exchange.js';
import cursor from '../components/cursor.js';
import curtain from '../components/curtain.js';
import curve from '../components/curve.js';
import cut1 from '../components/cut-1.js';
import cut from '../components/cut.js';
import dam1 from '../components/dam-1.js';
import dam2 from '../components/dam-2.js';
import dam3 from '../components/dam-3.js';
import dam4 from '../components/dam-4.js';
import dam5 from '../components/dam-5.js';
import dam6 from '../components/dam-6.js';
import dam7 from '../components/dam-7.js';
import dam from '../components/dam.js';
import dartBoard from '../components/dart-board.js';
import dashboard1 from '../components/dashboard-1.js';
import dashboard from '../components/dashboard.js';
import dataBase from '../components/data-base.js';
import dataChecked from '../components/data-checked.js';
import dataDisplay from '../components/data-display.js';
import dataError from '../components/data-error.js';
import dataSearch from '../components/data-search.js';
import data from '../components/data.js';
import delete1 from '../components/delete-1.js';
import deleteTime from '../components/delete-time.js';
import _delete from '../components/delete.js';
import delta from '../components/delta.js';
import depressed from '../components/depressed.js';
import desktop1 from '../components/desktop-1.js';
import desktop from '../components/desktop.js';
import despise from '../components/despise.js';
import device from '../components/device.js';
import discountFilled from '../components/discount-filled.js';
import discount from '../components/discount.js';
import dissatisfaction from '../components/dissatisfaction.js';
import divide from '../components/divide.js';
import dividers1 from '../components/dividers-1.js';
import dividers from '../components/dividers.js';
import doge from '../components/doge.js';
import doubleStorey from '../components/double-storey.js';
import download1 from '../components/download-1.js';
import download from '../components/download.js';
import downscale from '../components/downscale.js';
import dragDrop from '../components/drag-drop.js';
import dragMove from '../components/drag-move.js';
import drink from '../components/drink.js';
import drumstick from '../components/drumstick.js';
import dv from '../components/dv.js';
import dvd from '../components/dvd.js';
import earphone from '../components/earphone.js';
import earth from '../components/earth.js';
import edit1 from '../components/edit-1.js';
import edit2 from '../components/edit-2.js';
import editOff from '../components/edit-off.js';
import edit from '../components/edit.js';
import education from '../components/education.js';
import eggplant from '../components/eggplant.js';
import ellipsis from '../components/ellipsis.js';
import emoEmotional from '../components/emo-emotional.js';
import enter from '../components/enter.js';
import equal from '../components/equal.js';
import errorCircleFilled from '../components/error-circle-filled.js';
import errorCircle from '../components/error-circle.js';
import errorTriangle from '../components/error-triangle.js';
import error from '../components/error.js';
import excited1 from '../components/excited-1.js';
import excited from '../components/excited.js';
import expandHorizontal from '../components/expand-horizontal.js';
import expandVertical from '../components/expand-vertical.js';
import exploreOff from '../components/explore-off.js';
import explore from '../components/explore.js';
import exposure from '../components/exposure.js';
import extensionOff from '../components/extension-off.js';
import extension from '../components/extension.js';
import faceRetouching from '../components/face-retouching.js';
import factCheck from '../components/fact-check.js';
import fahrenheitScale from '../components/fahrenheit-scale.js';
import feelAtEase from '../components/feel-at-ease.js';
import ferocious from '../components/ferocious.js';
import ferrisWheel from '../components/ferris-wheel.js';
import file1 from '../components/file-1.js';
import fileAdd1 from '../components/file-add-1.js';
import fileAdd from '../components/file-add.js';
import fileAttachment from '../components/file-attachment.js';
import fileBlocked from '../components/file-blocked.js';
import fileCode1 from '../components/file-code-1.js';
import fileCode from '../components/file-code.js';
import fileCopy from '../components/file-copy.js';
import fileDownload from '../components/file-download.js';
import fileExcel from '../components/file-excel.js';
import fileExport from '../components/file-export.js';
import fileIcon from '../components/file-icon.js';
import fileImage from '../components/file-image.js';
import fileImport from '../components/file-import.js';
import fileLocked from '../components/file-locked.js';
import fileMinus from '../components/file-minus.js';
import fileMusic from '../components/file-music.js';
import fileOnenote from '../components/file-onenote.js';
import fileOutlook from '../components/file-outlook.js';
import filePaste from '../components/file-paste.js';
import filePdf from '../components/file-pdf.js';
import filePowerpoint from '../components/file-powerpoint.js';
import fileRestore from '../components/file-restore.js';
import fileSafety from '../components/file-safety.js';
import fileSearch from '../components/file-search.js';
import fileSetting from '../components/file-setting.js';
import fileTeams from '../components/file-teams.js';
import fileUnknown from '../components/file-unknown.js';
import fileUnlocked from '../components/file-unlocked.js';
import fileWord from '../components/file-word.js';
import fileZip from '../components/file-zip.js';
import file from '../components/file.js';
import fillColor1 from '../components/fill-color-1.js';
import fillColor from '../components/fill-color.js';
import film1 from '../components/film-1.js';
import film from '../components/film.js';
import filter1 from '../components/filter-1.js';
import filter2 from '../components/filter-2.js';
import filter3 from '../components/filter-3.js';
import filterClear from '../components/filter-clear.js';
import filterOff from '../components/filter-off.js';
import filter from '../components/filter.js';
import fingerprint1 from '../components/fingerprint-1.js';
import fingerprint2 from '../components/fingerprint-2.js';
import fingerprint3 from '../components/fingerprint-3.js';
import fingerprint from '../components/fingerprint.js';
import fish from '../components/fish.js';
import flag1 from '../components/flag-1.js';
import flag2 from '../components/flag-2.js';
import flag3 from '../components/flag-3.js';
import flag4 from '../components/flag-4.js';
import flag from '../components/flag.js';
import flashlight from '../components/flashlight.js';
import flightLanding from '../components/flight-landing.js';
import flightTakeoff from '../components/flight-takeoff.js';
import flipSmilingFace from '../components/flip-smiling-face.js';
import flipToBack from '../components/flip-to-back.js';
import flipToFront from '../components/flip-to-front.js';
import focus from '../components/focus.js';
import fogNight from '../components/fog-night.js';
import fogSunny from '../components/fog-sunny.js';
import fog from '../components/fog.js';
import folder1 from '../components/folder-1.js';
import folderAdd1 from '../components/folder-add-1.js';
import folderAdd from '../components/folder-add.js';
import folderBlocked from '../components/folder-blocked.js';
import folderDetails from '../components/folder-details.js';
import folderExport from '../components/folder-export.js';
import folderImport from '../components/folder-import.js';
import folderLocked from '../components/folder-locked.js';
import folderMinus from '../components/folder-minus.js';
import folderMove from '../components/folder-move.js';
import folderOff from '../components/folder-off.js';
import folderOpen1 from '../components/folder-open-1.js';
import folderOpen from '../components/folder-open.js';
import folderSearch from '../components/folder-search.js';
import folderSetting from '../components/folder-setting.js';
import folderShared from '../components/folder-shared.js';
import folderUnlocked from '../components/folder-unlocked.js';
import folderZip from '../components/folder-zip.js';
import folder from '../components/folder.js';
import forest from '../components/forest.js';
import fork from '../components/fork.js';
import form from '../components/form.js';
import formatHorizontalAlignBottom from '../components/format-horizontal-align-bottom.js';
import formatHorizontalAlignCenter from '../components/format-horizontal-align-center.js';
import formatHorizontalAlignTop from '../components/format-horizontal-align-top.js';
import formatVerticalAlignCenter from '../components/format-vertical-align-center.js';
import formatVerticalAlignLeft from '../components/format-vertical-align-left.js';
import formatVerticalAlignRight from '../components/format-vertical-align-right.js';
import forward from '../components/forward.js';
import frame1 from '../components/frame-1.js';
import frame from '../components/frame.js';
import fries from '../components/fries.js';
import fullscreen1 from '../components/fullscreen-1.js';
import fullscreen2 from '../components/fullscreen-2.js';
import fullscreenExit1 from '../components/fullscreen-exit-1.js';
import fullscreenExit from '../components/fullscreen-exit.js';
import fullscreen from '../components/fullscreen.js';
import functionCurve from '../components/function-curve.js';
import functions1 from '../components/functions-1.js';
import functions from '../components/functions.js';
import gamepad1 from '../components/gamepad-1.js';
import gamepad from '../components/gamepad.js';
import gamma from '../components/gamma.js';
import garlic from '../components/garlic.js';
import genderFemale from '../components/gender-female.js';
import genderMale from '../components/gender-male.js';
import gestureApplause from '../components/gesture-applause.js';
import gestureClick from '../components/gesture-click.js';
import gestureDown from '../components/gesture-down.js';
import gestureExpansion from '../components/gesture-expansion.js';
import gestureLeftSlip from '../components/gesture-left-slip.js';
import gestureLeft from '../components/gesture-left.js';
import gesturePray1 from '../components/gesture-pray-1.js';
import gesturePray from '../components/gesture-pray.js';
import gesturePress from '../components/gesture-press.js';
import gestureRanslation1 from '../components/gesture-ranslation-1.js';
import gestureRanslation from '../components/gesture-ranslation.js';
import gestureRightSlip from '../components/gesture-right-slip.js';
import gestureRight from '../components/gesture-right.js';
import gestureSlideUp from '../components/gesture-slide-up.js';
import gestureUp1 from '../components/gesture-up-1.js';
import gestureUp2 from '../components/gesture-up-2.js';
import gestureUpAndDown from '../components/gesture-up-and-down.js';
import gestureUp from '../components/gesture-up.js';
import gestureWipeDown from '../components/gesture-wipe-down.js';
import gift from '../components/gift.js';
import giggle from '../components/giggle.js';
import gitBranch from '../components/git-branch.js';
import gitCommit from '../components/git-commit.js';
import gitMerge from '../components/git-merge.js';
import gitPullRequest from '../components/git-pull-request.js';
import gitRepositoryCommits from '../components/git-repository-commits.js';
import gitRepositoryPrivate from '../components/git-repository-private.js';
import gitRepository from '../components/git-repository.js';
import gps from '../components/gps.js';
import grape from '../components/grape.js';
import greaterThanOrEqual from '../components/greater-than-or-equal.js';
import greaterThan from '../components/greater-than.js';
import greenOnion from '../components/green-onion.js';
import gridAdd from '../components/grid-add.js';
import gridView from '../components/grid-view.js';
import guitar from '../components/guitar.js';
import hamburger from '../components/hamburger.js';
import happy from '../components/happy.js';
import hardDiskStorage from '../components/hard-disk-storage.js';
import hardDrive from '../components/hard-drive.js';
import hashtag from '../components/hashtag.js';
import hd from '../components/hd.js';
import heartFilled from '../components/heart-filled.js';
import heart from '../components/heart.js';
import helpCircleFilled from '../components/help-circle-filled.js';
import helpCircle from '../components/help-circle.js';
import helpRectangle from '../components/help-rectangle.js';
import help from '../components/help.js';
import highlight1 from '../components/highlight-1.js';
import highlight from '../components/highlight.js';
import historySetting from '../components/history-setting.js';
import history from '../components/history.js';
import home from '../components/home.js';
import hospital1 from '../components/hospital-1.js';
import hospital from '../components/hospital.js';
import hotspotWave from '../components/hotspot-wave.js';
import hourglass from '../components/hourglass.js';
import houses1 from '../components/houses-1.js';
import houses2 from '../components/houses-2.js';
import houses from '../components/houses.js';
import html5 from '../components/html5.js';
import https from '../components/https.js';
import iceCream from '../components/ice-cream.js';
import icon from '../components/icon.js';
import image1 from '../components/image-1.js';
import imageAdd from '../components/image-add.js';
import imageEdit from '../components/image-edit.js';
import imageError from '../components/image-error.js';
import imageOff from '../components/image-off.js';
import imageSearch from '../components/image-search.js';
import image from '../components/image.js';
import indentLeft from '../components/indent-left.js';
import indentRight from '../components/indent-right.js';
import indicator from '../components/indicator.js';
import infoCircleFilled from '../components/info-circle-filled.js';
import infoCircle from '../components/info-circle.js';
import ink from '../components/ink.js';
import installDesktop from '../components/install-desktop.js';
import installMobile from '../components/install-mobile.js';
import install from '../components/install.js';
import institutionChecked from '../components/institution-checked.js';
import institution from '../components/institution.js';
import internet from '../components/internet.js';
import ipod from '../components/ipod.js';
import joyful from '../components/joyful.js';
import jumpOff from '../components/jump-off.js';
import jump from '../components/jump.js';
import keyboard from '../components/keyboard.js';
import laptop from '../components/laptop.js';
import layers from '../components/layers.js';
import layout from '../components/layout.js';
import leaderboard from '../components/leaderboard.js';
import lemonSlice from '../components/lemon-slice.js';
import lemon from '../components/lemon.js';
import lessThanOrEqual from '../components/less-than-or-equal.js';
import lessThan from '../components/less-than.js';
import lettersA from '../components/letters-a.js';
import lettersB from '../components/letters-b.js';
import lettersC from '../components/letters-c.js';
import lettersD from '../components/letters-d.js';
import lettersE from '../components/letters-e.js';
import lettersF from '../components/letters-f.js';
import lettersG from '../components/letters-g.js';
import lettersH from '../components/letters-h.js';
import lettersI from '../components/letters-i.js';
import lettersJ from '../components/letters-j.js';
import lettersK from '../components/letters-k.js';
import lettersL from '../components/letters-l.js';
import lettersM from '../components/letters-m.js';
import lettersN from '../components/letters-n.js';
import lettersO from '../components/letters-o.js';
import lettersP from '../components/letters-p.js';
import lettersQ from '../components/letters-q.js';
import lettersR from '../components/letters-r.js';
import lettersS from '../components/letters-s.js';
import lettersT from '../components/letters-t.js';
import lettersU from '../components/letters-u.js';
import lettersV from '../components/letters-v.js';
import lettersW from '../components/letters-w.js';
import lettersX from '../components/letters-x.js';
import lettersY from '../components/letters-y.js';
import lettersZ from '../components/letters-z.js';
import lightbulbCircle from '../components/lightbulb-circle.js';
import lightbulb from '../components/lightbulb.js';
import lighthouse1 from '../components/lighthouse-1.js';
import lighthouse2 from '../components/lighthouse-2.js';
import lighthouse from '../components/lighthouse.js';
import lightingCircle from '../components/lighting-circle.js';
import lineHeight from '../components/line-height.js';
import link1 from '../components/link-1.js';
import linkUnlink from '../components/link-unlink.js';
import link from '../components/link.js';
import liquor from '../components/liquor.js';
import listNumbered from '../components/list-numbered.js';
import list from '../components/list.js';
import load from '../components/load.js';
import loading from '../components/loading.js';
import location1 from '../components/location-1.js';
import locationEnlargement from '../components/location-enlargement.js';
import locationError from '../components/location-error.js';
import locationParkingPlace from '../components/location-parking-place.js';
import locationReduction from '../components/location-reduction.js';
import locationSetting from '../components/location-setting.js';
import location from '../components/location.js';
import lockOffFilled from '../components/lock-off-filled.js';
import lockOff from '../components/lock-off.js';
import lockOnFilled from '../components/lock-on-filled.js';
import lockOn from '../components/lock-on.js';
import lockTime from '../components/lock-time.js';
import login from '../components/login.js';
import logoAdobeIllustrate from '../components/logo-adobe-illustrate.js';
import logoAdobePhotoshop1 from '../components/logo-adobe-photoshop-1.js';
import logoAdobePhotoshop from '../components/logo-adobe-photoshop.js';
import logoAndroid from '../components/logo-android.js';
import logoAppleFilled from '../components/logo-apple-filled.js';
import logoApple from '../components/logo-apple.js';
import logoBehance from '../components/logo-behance.js';
import logoChromeFilled from '../components/logo-chrome-filled.js';
import logoChrome from '../components/logo-chrome.js';
import logoCinema4d from '../components/logo-cinema4d.js';
import logoCodepen from '../components/logo-codepen.js';
import logoCodesandbox from '../components/logo-codesandbox.js';
import logoDribbble from '../components/logo-dribbble.js';
import logoFacebook from '../components/logo-facebook.js';
import logoFigma from '../components/logo-figma.js';
import logoFramer from '../components/logo-framer.js';
import logoGithubFilled from '../components/logo-github-filled.js';
import logoGithub from '../components/logo-github.js';
import logoGitlab from '../components/logo-gitlab.js';
import logoIeFilled from '../components/logo-ie-filled.js';
import logoIe from '../components/logo-ie.js';
import logoInstagram from '../components/logo-instagram.js';
import logoQq from '../components/logo-qq.js';
import logoTwitter from '../components/logo-twitter.js';
import logoWechatStroke from '../components/logo-wechat-stroke.js';
import logoWechat from '../components/logo-wechat.js';
import logoWecom from '../components/logo-wecom.js';
import logoWindowsFilled from '../components/logo-windows-filled.js';
import logoWindows from '../components/logo-windows.js';
import logoYoutube from '../components/logo-youtube.js';
import logout from '../components/logout.js';
import lookAround from '../components/look-around.js';
import loudspeaker from '../components/loudspeaker.js';
import mail from '../components/mail.js';
import map3d from '../components/map-3d.js';
import mapAdd from '../components/map-add.js';
import mapAiming from '../components/map-aiming.js';
import mapBlocked from '../components/map-blocked.js';
import mapBubble from '../components/map-bubble.js';
import mapCancel from '../components/map-cancel.js';
import mapChat from '../components/map-chat.js';
import mapChecked from '../components/map-checked.js';
import mapCollection from '../components/map-collection.js';
import mapConnection from '../components/map-connection.js';
import mapDistance from '../components/map-distance.js';
import mapDouble from '../components/map-double.js';
import mapEdit from '../components/map-edit.js';
import mapGrid from '../components/map-grid.js';
import mapInformation1 from '../components/map-information-1.js';
import mapInformation2 from '../components/map-information-2.js';
import mapInformation from '../components/map-information.js';
import mapLocation from '../components/map-location.js';
import mapLocked from '../components/map-locked.js';
import mapMarked from '../components/map-marked.js';
import mapNavigation from '../components/map-navigation.js';
import mapOutline from '../components/map-outline.js';
import mapRoutePlanning from '../components/map-route-planning.js';
import mapRuler from '../components/map-ruler.js';
import mapSafety from '../components/map-safety.js';
import mapSearch1 from '../components/map-search-1.js';
import mapSearch from '../components/map-search.js';
import mapSetting from '../components/map-setting.js';
import mapUnlocked from '../components/map-unlocked.js';
import map from '../components/map.js';
import markAsUnread from '../components/mark-as-unread.js';
import markup from '../components/markup.js';
import mathematics from '../components/mathematics.js';
import measurement1 from '../components/measurement-1.js';
import measurement2 from '../components/measurement-2.js';
import measurement from '../components/measurement.js';
import meatPepper from '../components/meat-pepper.js';
import mediaLibrary from '../components/media-library.js';
import member from '../components/member.js';
import menuApplication from '../components/menu-application.js';
import menuFold from '../components/menu-fold.js';
import menuUnfold from '../components/menu-unfold.js';
import menu from '../components/menu.js';
import mergeCells from '../components/merge-cells.js';
import microphone1 from '../components/microphone-1.js';
import microphone2 from '../components/microphone-2.js';
import microphone from '../components/microphone.js';
import milk from '../components/milk.js';
import minusCircleFilled from '../components/minus-circle-filled.js';
import minusCircle from '../components/minus-circle.js';
import minusRectangleFilled from '../components/minus-rectangle-filled.js';
import minusRectangle from '../components/minus-rectangle.js';
import minus from '../components/minus.js';
import mirror from '../components/mirror.js';
import mobileBlocked from '../components/mobile-blocked.js';
import mobileList from '../components/mobile-list.js';
import mobileNavigation from '../components/mobile-navigation.js';
import mobileShortcut from '../components/mobile-shortcut.js';
import mobileVibrate from '../components/mobile-vibrate.js';
import mobile from '../components/mobile.js';
import modeDark from '../components/mode-dark.js';
import modeLight from '../components/mode-light.js';
import module from '../components/module.js';
import money from '../components/money.js';
import monument from '../components/monument.js';
import moonFall from '../components/moon-fall.js';
import moonRising from '../components/moon-rising.js';
import moon from '../components/moon.js';
import more from '../components/more.js';
import mosque1 from '../components/mosque-1.js';
import mosque from '../components/mosque.js';
import mouse from '../components/mouse.js';
import move1 from '../components/move-1.js';
import move from '../components/move.js';
import movieClapper from '../components/movie-clapper.js';
import multiply from '../components/multiply.js';
import museum1 from '../components/museum-1.js';
import museum2 from '../components/museum-2.js';
import museum from '../components/museum.js';
import mushroom1 from '../components/mushroom-1.js';
import mushroom from '../components/mushroom.js';
import music1 from '../components/music-1.js';
import music2 from '../components/music-2.js';
import musicRectangleAdd from '../components/music-rectangle-add.js';
import music from '../components/music.js';
import navigationArrow from '../components/navigation-arrow.js';
import next from '../components/next.js';
import noExpression from '../components/no-expression.js';
import noodle from '../components/noodle.js';
import notificationAdd from '../components/notification-add.js';
import notificationCircle from '../components/notification-circle.js';
import notificationError from '../components/notification-error.js';
import notificationFilled from '../components/notification-filled.js';
import notification from '../components/notification.js';
import numbers01 from '../components/numbers-0-1.js';
import numbers0 from '../components/numbers-0.js';
import numbers11 from '../components/numbers-1-1.js';
import numbers1 from '../components/numbers-1.js';
import numbers21 from '../components/numbers-2-1.js';
import numbers2 from '../components/numbers-2.js';
import numbers31 from '../components/numbers-3-1.js';
import numbers3 from '../components/numbers-3.js';
import numbers41 from '../components/numbers-4-1.js';
import numbers4 from '../components/numbers-4.js';
import numbers51 from '../components/numbers-5-1.js';
import numbers5 from '../components/numbers-5.js';
import numbers61 from '../components/numbers-6-1.js';
import numbers6 from '../components/numbers-6.js';
import numbers71 from '../components/numbers-7-1.js';
import numbers7 from '../components/numbers-7.js';
import numbers81 from '../components/numbers-8-1.js';
import numbers8 from '../components/numbers-8.js';
import numbers91 from '../components/numbers-9-1.js';
import numbers9 from '../components/numbers-9.js';
import nut from '../components/nut.js';
import objectStorage from '../components/object-storage.js';
import openMouth from '../components/open-mouth.js';
import opera from '../components/opera.js';
import orderAdjustmentColumn from '../components/order-adjustment-column.js';
import orderAscending from '../components/order-ascending.js';
import orderDescending from '../components/order-descending.js';
import outbox from '../components/outbox.js';
import pageFirst from '../components/page-first.js';
import pageHead from '../components/page-head.js';
import pageLast from '../components/page-last.js';
import palace1 from '../components/palace-1.js';
import palace2 from '../components/palace-2.js';
import palace3 from '../components/palace-3.js';
import palace4 from '../components/palace-4.js';
import palace from '../components/palace.js';
import palette1 from '../components/palette-1.js';
import palette from '../components/palette.js';
import panoramaHorizontal from '../components/panorama-horizontal.js';
import panoramaVertical from '../components/panorama-vertical.js';
import pantone from '../components/pantone.js';
import parabola from '../components/parabola.js';
import parentheses from '../components/parentheses.js';
import paste from '../components/paste.js';
import patio from '../components/patio.js';
import pauseCircleFilled from '../components/pause-circle-filled.js';
import pauseCircleStroke from '../components/pause-circle-stroke.js';
import pauseCircle from '../components/pause-circle.js';
import pause from '../components/pause.js';
import pea from '../components/pea.js';
import peach from '../components/peach.js';
import pear from '../components/pear.js';
import pearlOfTheOrient from '../components/pearl-of-the-orient.js';
import penBall from '../components/pen-ball.js';
import penBrush from '../components/pen-brush.js';
import penMark from '../components/pen-mark.js';
import penQuill from '../components/pen-quill.js';
import pen from '../components/pen.js';
import pending from '../components/pending.js';
import percent from '../components/percent.js';
import personalInformation from '../components/personal-information.js';
import phoneLocked from '../components/phone-locked.js';
import phoneSearch from '../components/phone-search.js';
import pi from '../components/pi.js';
import piano from '../components/piano.js';
import pinFilled from '../components/pin-filled.js';
import pin from '../components/pin.js';
import playCircleFilled from '../components/play-circle-filled.js';
import playCircleStrokeAdd from '../components/play-circle-stroke-add.js';
import playCircleStroke from '../components/play-circle-stroke.js';
import playCircle from '../components/play-circle.js';
import playDemo from '../components/play-demo.js';
import playRectangle from '../components/play-rectangle.js';
import play from '../components/play.js';
import plus from '../components/plus.js';
import popsicle from '../components/popsicle.js';
import portrait from '../components/portrait.js';
import pout from '../components/pout.js';
import poweroff from '../components/poweroff.js';
import preciseMonitor from '../components/precise-monitor.js';
import previous from '../components/previous.js';
import print from '../components/print.js';
import pumpkin from '../components/pumpkin.js';
import pyramidMaya from '../components/pyramid-maya.js';
import pyramid from '../components/pyramid.js';
import qrcode from '../components/qrcode.js';
import quadratic from '../components/quadratic.js';
import questionnaire from '../components/questionnaire.js';
import queue from '../components/queue.js';
import radar from '../components/radar.js';
import radio1 from '../components/radio-1.js';
import radio2 from '../components/radio-2.js';
import radish from '../components/radish.js';
import rainHeavy from '../components/rain-heavy.js';
import rainLight from '../components/rain-light.js';
import rainMedium from '../components/rain-medium.js';
import rainbow from '../components/rainbow.js';
import rectangle from '../components/rectangle.js';
import refresh from '../components/refresh.js';
import relation from '../components/relation.js';
import relativity from '../components/relativity.js';
import remoteWave from '../components/remote-wave.js';
import remove from '../components/remove.js';
import replay from '../components/replay.js';
import riceBall from '../components/rice-ball.js';
import rice from '../components/rice.js';
import roast from '../components/roast.js';
import rocket from '../components/rocket.js';
import rollback from '../components/rollback.js';
import rollfront from '../components/rollfront.js';
import rootList from '../components/root-list.js';
import rotateLocked from '../components/rotate-locked.js';
import rotate from '../components/rotate.js';
import rotation from '../components/rotation.js';
import round from '../components/round.js';
import routerWave from '../components/router-wave.js';
import rss from '../components/rss.js';
import ruler from '../components/ruler.js';
import sailingHotel from '../components/sailing-hotel.js';
import sandwich from '../components/sandwich.js';
import saturation from '../components/saturation.js';
import sausage from '../components/sausage.js';
import save from '../components/save.js';
import savingPot from '../components/saving-pot.js';
import scan from '../components/scan.js';
import screen4k from '../components/screen-4k.js';
import screencast from '../components/screencast.js';
import screenshot from '../components/screenshot.js';
import scrollBar from '../components/scroll-bar.js';
import sdCard1 from '../components/sd-card-1.js';
import sdCard from '../components/sd-card.js';
import searchError from '../components/search-error.js';
import search from '../components/search.js';
import secured from '../components/secured.js';
import sendCancel from '../components/send-cancel.js';
import send from '../components/send.js';
import sensors1 from '../components/sensors-1.js';
import sensors2 from '../components/sensors-2.js';
import sensorsOff from '../components/sensors-off.js';
import sensors from '../components/sensors.js';
import serenity from '../components/serenity.js';
import server from '../components/server.js';
import service from '../components/service.js';
import setting1 from '../components/setting-1.js';
import setting from '../components/setting.js';
import share1 from '../components/share-1.js';
import share from '../components/share.js';
import sharpness from '../components/sharpness.js';
import shieldError from '../components/shield-error.js';
import shimen from '../components/shimen.js';
import shop1 from '../components/shop-1.js';
import shop2 from '../components/shop-2.js';
import shop3 from '../components/shop-3.js';
import shop4 from '../components/shop-4.js';
import shop5 from '../components/shop-5.js';
import shop from '../components/shop.js';
import shrimp from '../components/shrimp.js';
import shrinkHorizontal from '../components/shrink-horizontal.js';
import shrinkVertical from '../components/shrink-vertical.js';
import shutter from '../components/shutter.js';
import shutup from '../components/shutup.js';
import simCard1 from '../components/sim-card-1.js';
import simCard2 from '../components/sim-card-2.js';
import simCard from '../components/sim-card.js';
import sinisterSmile from '../components/sinister-smile.js';
import sip from '../components/sip.js';
import slash from '../components/slash.js';
import sleep from '../components/sleep.js';
import slice from '../components/slice.js';
import slideshow from '../components/slideshow.js';
import smile from '../components/smile.js';
import sneer from '../components/sneer.js';
import snowflake from '../components/snowflake.js';
import sonic from '../components/sonic.js';
import soundDown from '../components/sound-down.js';
import soundHigh from '../components/sound-high.js';
import soundLow from '../components/sound-low.js';
import soundMute1 from '../components/sound-mute-1.js';
import soundMute from '../components/sound-mute.js';
import soundUp from '../components/sound-up.js';
import sound from '../components/sound.js';
import space from '../components/space.js';
import speechless1 from '../components/speechless-1.js';
import starFilled from '../components/star-filled.js';
import star from '../components/star.js';
import statueOfJesus from '../components/statue-of-jesus.js';
import stickyNote from '../components/sticky-note.js';
import stopCircleFilled from '../components/stop-circle-filled.js';
import stopCircleStroke from '../components/stop-circle-stroke.js';
import stopCircle from '../components/stop-circle.js';
import stop from '../components/stop.js';
import store from '../components/store.js';
import streetRoad1 from '../components/street-road-1.js';
import streetRoad from '../components/street-road.js';
import subtitle from '../components/subtitle.js';
import subwayLine from '../components/subway-line.js';
import sum from '../components/sum.js';
import sunFall from '../components/sun-fall.js';
import sunRising from '../components/sun-rising.js';
import sunny from '../components/sunny.js';
import support from '../components/support.js';
import surprised1 from '../components/surprised-1.js';
import surprised from '../components/surprised.js';
import swapLeft from '../components/swap-left.js';
import swapRight from '../components/swap-right.js';
import swap from '../components/swap.js';
import swear1 from '../components/swear-1.js';
import swear2 from '../components/swear-2.js';
import system2 from '../components/system-2.js';
import system3 from '../components/system-3.js';
import systemApplication from '../components/system-application.js';
import systemBlocked from '../components/system-blocked.js';
import systemCode from '../components/system-code.js';
import systemComponents from '../components/system-components.js';
import systemCoordinate from '../components/system-coordinate.js';
import systemDevice from '../components/system-device.js';
import systemInterface from '../components/system-interface.js';
import systemLocation from '../components/system-location.js';
import systemLocked from '../components/system-locked.js';
import systemLog from '../components/system-log.js';
import systemMarked from '../components/system-marked.js';
import systemMessages from '../components/system-messages.js';
import systemRegulation from '../components/system-regulation.js';
import systemSearch from '../components/system-search.js';
import systemSetting from '../components/system-setting.js';
import systemStorage from '../components/system-storage.js';
import systemSum from '../components/system-sum.js';
import systemUnlocked from '../components/system-unlocked.js';
import tab from '../components/tab.js';
import table1 from '../components/table-1.js';
import table2 from '../components/table-2.js';
import tableAdd from '../components/table-add.js';
import tableSplit from '../components/table-split.js';
import table from '../components/table.js';
import tag from '../components/tag.js';
import tangerinr from '../components/tangerinr.js';
import tape from '../components/tape.js';
import task1 from '../components/task-1.js';
import taskAdd1 from '../components/task-add-1.js';
import taskAdd from '../components/task-add.js';
import taskChecked from '../components/task-checked.js';
import taskError from '../components/task-error.js';
import taskLocation from '../components/task-location.js';
import taskMarked from '../components/task-marked.js';
import taskSetting from '../components/task-setting.js';
import taskVisible from '../components/task-visible.js';
import task from '../components/task.js';
import tea from '../components/tea.js';
import teahouse from '../components/teahouse.js';
import template from '../components/template.js';
import temple from '../components/temple.js';
import terminalRectangle1 from '../components/terminal-rectangle-1.js';
import terminalRectangle from '../components/terminal-rectangle.js';
import terminalWindow from '../components/terminal-window.js';
import terminal from '../components/terminal.js';
import textbox from '../components/textbox.js';
import textformatBold from '../components/textformat-bold.js';
import textformatColor from '../components/textformat-color.js';
import textformatItalic from '../components/textformat-italic.js';
import textformatStrikethrough from '../components/textformat-strikethrough.js';
import textformatUnderline from '../components/textformat-underline.js';
import textformatWrap from '../components/textformat-wrap.js';
import theaters from '../components/theaters.js';
import thumbDown1 from '../components/thumb-down-1.js';
import thumbDown2 from '../components/thumb-down-2.js';
import thumbDown from '../components/thumb-down.js';
import thumbUp1 from '../components/thumb-up-1.js';
import thumbUp2 from '../components/thumb-up-2.js';
import thumbUp from '../components/thumb-up.js';
import thunder from '../components/thunder.js';
import thunderstormNight from '../components/thunderstorm-night.js';
import thunderstormSunny from '../components/thunderstorm-sunny.js';
import thunderstorm from '../components/thunderstorm.js';
import ticket from '../components/ticket.js';
import timeFilled from '../components/time-filled.js';
import time from '../components/time.js';
import tipsDouble from '../components/tips-double.js';
import tips from '../components/tips.js';
import tomato from '../components/tomato.js';
import toolsCircle from '../components/tools-circle.js';
import tools from '../components/tools.js';
import tornado from '../components/tornado.js';
import tower1 from '../components/tower-1.js';
import tower2 from '../components/tower-2.js';
import tower3 from '../components/tower-3.js';
import towerClock from '../components/tower-clock.js';
import tower from '../components/tower.js';
import town from '../components/town.js';
import trafficEvents from '../components/traffic-events.js';
import traffic from '../components/traffic.js';
import transform1 from '../components/transform-1.js';
import transform2 from '../components/transform-2.js';
import transform3 from '../components/transform-3.js';
import transform from '../components/transform.js';
import translate1 from '../components/translate-1.js';
import translate from '../components/translate.js';
import treeList from '../components/tree-list.js';
import treeRoundDotVertical from '../components/tree-round-dot-vertical.js';
import treeRoundDot from '../components/tree-round-dot.js';
import treeSquareDotVertical from '../components/tree-square-dot-vertical.js';
import treeSquareDot from '../components/tree-square-dot.js';
import trendingDown from '../components/trending-down.js';
import trendingUp from '../components/trending-up.js';
import tv1 from '../components/tv-1.js';
import tv2 from '../components/tv-2.js';
import tv from '../components/tv.js';
import typography from '../components/typography.js';
import uncomfortable1 from '../components/uncomfortable-1.js';
import uncomfortable2 from '../components/uncomfortable-2.js';
import uncomfortable from '../components/uncomfortable.js';
import undertakeDelivery from '../components/undertake-delivery.js';
import undertakeEnvironmentProtection from '../components/undertake-environment-protection.js';
import undertakeHoldUp from '../components/undertake-hold-up.js';
import undertakeTransaction from '../components/undertake-transaction.js';
import undertake from '../components/undertake.js';
import unfoldLess from '../components/unfold-less.js';
import unfoldMore from '../components/unfold-more.js';
import unhappy1 from '../components/unhappy-1.js';
import unhappy from '../components/unhappy.js';
import uninstall from '../components/uninstall.js';
import upload1 from '../components/upload-1.js';
import upload from '../components/upload.js';
import upscale from '../components/upscale.js';
import usb from '../components/usb.js';
import user1 from '../components/user-1.js';
import userAdd from '../components/user-add.js';
import userArrowDown from '../components/user-arrow-down.js';
import userArrowLeft from '../components/user-arrow-left.js';
import userArrowRight from '../components/user-arrow-right.js';
import userArrowUp from '../components/user-arrow-up.js';
import userAvatar from '../components/user-avatar.js';
import userBlocked from '../components/user-blocked.js';
import userBusiness from '../components/user-business.js';
import userChecked1 from '../components/user-checked-1.js';
import userChecked from '../components/user-checked.js';
import userCircle from '../components/user-circle.js';
import userClear from '../components/user-clear.js';
import userError1 from '../components/user-error-1.js';
import userInvisible from '../components/user-invisible.js';
import userList from '../components/user-list.js';
import userLocked from '../components/user-locked.js';
import userMarked from '../components/user-marked.js';
import userPassword from '../components/user-password.js';
import userSafety from '../components/user-safety.js';
import userSearch from '../components/user-search.js';
import userSetting from '../components/user-setting.js';
import userTalk1 from '../components/user-talk-1.js';
import userTalkOff1 from '../components/user-talk-off-1.js';
import userTalk from '../components/user-talk.js';
import userTime from '../components/user-time.js';
import userTransmit from '../components/user-transmit.js';
import userUnknown from '../components/user-unknown.js';
import userUnlocked from '../components/user-unlocked.js';
import userVip from '../components/user-vip.js';
import userVisible from '../components/user-visible.js';
import user from '../components/user.js';
import usergroupAdd from '../components/usergroup-add.js';
import usergroupClear from '../components/usergroup-clear.js';
import usergroup from '../components/usergroup.js';
import vehicle from '../components/vehicle.js';
import verified from '../components/verified.js';
import verify from '../components/verify.js';
import videoCamera1 from '../components/video-camera-1.js';
import videoCamera2 from '../components/video-camera-2.js';
import videoCameraDollar from '../components/video-camera-dollar.js';
import videoCameraMinus from '../components/video-camera-minus.js';
import videoCameraMusic from '../components/video-camera-music.js';
import videoCameraOff from '../components/video-camera-off.js';
import videoCamera from '../components/video-camera.js';
import videoLibrary from '../components/video-library.js';
import video from '../components/video.js';
import viewAgenda from '../components/view-agenda.js';
import viewColumn from '../components/view-column.js';
import viewInAr from '../components/view-in-ar.js';
import viewList from '../components/view-list.js';
import viewModule from '../components/view-module.js';
import visualRecognition from '../components/visual-recognition.js';
import wallet from '../components/wallet.js';
import watch from '../components/watch.js';
import watermelon from '../components/watermelon.js';
import waveLeft from '../components/wave-left.js';
import waveRight from '../components/wave-right.js';
import wealth1 from '../components/wealth-1.js';
import wealth from '../components/wealth.js';
import widget from '../components/widget.js';
import wifi1 from '../components/wifi-1.js';
import wifiOff1 from '../components/wifi-off-1.js';
import wifiOff from '../components/wifi-off.js';
import wifi from '../components/wifi.js';
import window1 from '../components/window-1.js';
import window from '../components/window.js';
import windyRain from '../components/windy-rain.js';
import windy from '../components/windy.js';
import wink from '../components/wink.js';
import workHistory from '../components/work-history.js';
import workOff from '../components/work-off.js';
import work from '../components/work.js';
import wrySmile from '../components/wry-smile.js';
import zoomIn from '../components/zoom-in.js';
import zoomOut from '../components/zoom-out.js';

var icons = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ActivityIcon: activity,
	AddAndSubtractIcon: addAndSubtract,
	AddCircleIcon: addCircle,
	AddRectangleIcon: addRectangle,
	AddIcon: add,
	AddressBookIcon: addressBook,
	AdjustmentIcon: adjustment,
	AirplayWaveIcon: airplayWave,
	AlarmAddIcon: alarmAdd,
	AlarmOffIcon: alarmOff,
	AlarmIcon: alarm,
	AlignTopIcon: alignTop,
	AlignVerticalIcon: alignVertical,
	AlphaIcon: alpha,
	AnalyticsIcon: analytics,
	AnchorIcon: anchor,
	AngryIcon: angry,
	Animation1Icon: animation1,
	AnimationIcon: animation,
	AnticlockwiseIcon: anticlockwise,
	ApiIcon: api,
	AppIcon: app,
	AppleIcon: apple,
	ApplicationIcon: application,
	ArchitectureHuiStyleIcon: architectureHuiStyle,
	Archway1Icon: archway1,
	ArchwayIcon: archway,
	ArrowDownCircleIcon: arrowDownCircle,
	ArrowDownRectangleIcon: arrowDownRectangle,
	ArrowDownIcon: arrowDown,
	ArrowLeftCircleIcon: arrowLeftCircle,
	ArrowLeftDownCircleIcon: arrowLeftDownCircle,
	ArrowLeftDownIcon: arrowLeftDown,
	ArrowLeftRight1Icon: arrowLeftRight1,
	ArrowLeftRight2Icon: arrowLeftRight2,
	ArrowLeftRight3Icon: arrowLeftRight3,
	ArrowLeftRightCircleIcon: arrowLeftRightCircle,
	ArrowLeftUpCircleIcon: arrowLeftUpCircle,
	ArrowLeftUpIcon: arrowLeftUp,
	ArrowLeftIcon: arrowLeft,
	ArrowRightCircleIcon: arrowRightCircle,
	ArrowRightDownCircleIcon: arrowRightDownCircle,
	ArrowRightDownIcon: arrowRightDown,
	ArrowRightUpCircleIcon: arrowRightUpCircle,
	ArrowRightUpIcon: arrowRightUp,
	ArrowRightIcon: arrowRight,
	ArrowTriangleDownFilledIcon: arrowTriangleDownFilled,
	ArrowTriangleDownIcon: arrowTriangleDown,
	ArrowTriangleUpFilledIcon: arrowTriangleUpFilled,
	ArrowTriangleUpIcon: arrowTriangleUp,
	ArrowUpCircleIcon: arrowUpCircle,
	ArrowUpDown1Icon: arrowUpDown1,
	ArrowUpDown2Icon: arrowUpDown2,
	ArrowUpDown3Icon: arrowUpDown3,
	ArrowUpDownCircleIcon: arrowUpDownCircle,
	ArrowUpIcon: arrowUp,
	ArtboardIcon: artboard,
	ArticleIcon: article,
	AssignmentCheckedIcon: assignmentChecked,
	AssignmentCodeIcon: assignmentCode,
	AssignmentErrorIcon: assignmentError,
	AssignmentUserIcon: assignmentUser,
	AssignmentIcon: assignment,
	AttachIcon: attach,
	Attic1Icon: attic1,
	AtticIcon: attic,
	AudioIcon: audio,
	AwkwardIcon: awkward,
	BacktopRectangleIcon: backtopRectangle,
	BacktopIcon: backtop,
	BackupIcon: backup,
	BackwardIcon: backward,
	BadLaughIcon: badLaugh,
	BambooShootIcon: bambooShoot,
	BananaIcon: banana,
	BarbecueIcon: barbecue,
	Barcode1Icon: barcode1,
	BarcodeIcon: barcode,
	BaseStationIcon: baseStation,
	BatteryAddIcon: batteryAdd,
	BatteryChargingIcon: batteryCharging,
	BatteryLowIcon: batteryLow,
	BatteryIcon: battery,
	BeanIcon: bean,
	BeerIcon: beer,
	BetaIcon: beta,
	BifurcateIcon: bifurcate,
	BillIcon: bill,
	BlockchainIcon: blockchain,
	BluetoothIcon: bluetooth,
	BoneIcon: bone,
	BookOpenIcon: bookOpen,
	BookIcon: book,
	BookmarkAddIcon: bookmarkAdd,
	BookmarkCheckedIcon: bookmarkChecked,
	BookmarkDoubleIcon: bookmarkDouble,
	BookmarkMinusIcon: bookmarkMinus,
	BookmarkIcon: bookmark,
	BracesIcon: braces,
	BracketsIcon: brackets,
	BreadIcon: bread,
	Bridge1Icon: bridge1,
	Bridge2Icon: bridge2,
	Bridge3Icon: bridge3,
	Bridge4Icon: bridge4,
	Bridge5Icon: bridge5,
	Bridge6Icon: bridge6,
	BridgeIcon: bridge,
	Brightness1Icon: brightness1,
	BrightnessIcon: brightness,
	BroccoliIcon: broccoli,
	BrowseGalleryIcon: browseGallery,
	BrowseOffIcon: browseOff,
	BrowseIcon: browse,
	BrushIcon: brush,
	BugReportIcon: bugReport,
	BugIcon: bug,
	Building1Icon: building1,
	Building2Icon: building2,
	Building3Icon: building3,
	Building4Icon: building4,
	Building5Icon: building5,
	BuildingIcon: building,
	BulletpointIcon: bulletpoint,
	ButtonIcon: button,
	CabbageIcon: cabbage,
	CakeIcon: cake,
	Calculation1Icon: calculation1,
	CalculationIcon: calculation,
	Calculator1Icon: calculator1,
	CalculatorIcon: calculator,
	Calendar1Icon: calendar1,
	Calendar2Icon: calendar2,
	CalendarEditIcon: calendarEdit,
	CalendarEventIcon: calendarEvent,
	CalendarIcon: calendar,
	Call1Icon: call1,
	CallCancelIcon: callCancel,
	CallForwardedIcon: callForwarded,
	CallIncomingIcon: callIncoming,
	CallOffIcon: callOff,
	CallIcon: call,
	Calm1Icon: calm1,
	CalmIcon: calm,
	Camera1Icon: camera1,
	Camera2Icon: camera2,
	CameraOffIcon: cameraOff,
	CameraIcon: camera,
	CandyIcon: candy,
	CardIcon: card,
	CardmembershipIcon: cardmembership,
	CaretDownSmallIcon: caretDownSmall,
	CaretDownIcon: caretDown,
	CaretLeftSmallIcon: caretLeftSmall,
	CaretLeftIcon: caretLeft,
	CaretRightSmallIcon: caretRightSmall,
	CaretRightIcon: caretRight,
	CaretUpSmallIcon: caretUpSmall,
	CaretUpIcon: caretUp,
	CartAddIcon: cartAdd,
	CartIcon: cart,
	CastIcon: cast,
	Castle1Icon: castle1,
	Castle2Icon: castle2,
	Castle3Icon: castle3,
	Castle4Icon: castle4,
	Castle5Icon: castle5,
	Castle6Icon: castle6,
	Castle7Icon: castle7,
	CastleIcon: castle,
	CatIcon: cat,
	CatalogIcon: catalog,
	CdIcon: cd,
	CelsiusIcon: celsius,
	CenterFocusStrongIcon: centerFocusStrong,
	CentimeterIcon: centimeter,
	Certificate1Icon: certificate1,
	CertificateIcon: certificate,
	Chart3DIcon: chart3d,
	ChartAddIcon: chartAdd,
	ChartAnalyticsIcon: chartAnalytics,
	ChartAreaMultiIcon: chartAreaMulti,
	ChartAreaIcon: chartArea,
	ChartBarIcon: chartBar,
	ChartBubbleIcon: chartBubble,
	ChartColumnIcon: chartColumn,
	ChartComboIcon: chartCombo,
	ChartLineData1Icon: chartLineData1,
	ChartLineDataIcon: chartLineData,
	ChartLineMultiIcon: chartLineMulti,
	ChartLineIcon: chartLine,
	ChartMaximumIcon: chartMaximum,
	ChartMedianIcon: chartMedian,
	ChartMinimumIcon: chartMinimum,
	ChartPieIcon: chartPie,
	ChartRadarIcon: chartRadar,
	ChartRadialIcon: chartRadial,
	ChartRing1Icon: chartRing1,
	ChartRingIcon: chartRing,
	ChartScatterIcon: chartScatter,
	ChartStackedIcon: chartStacked,
	ChartIcon: chart,
	ChatAddIcon: chatAdd,
	ChatBubble1Icon: chatBubble1,
	ChatBubbleAddIcon: chatBubbleAdd,
	ChatBubbleErrorIcon: chatBubbleError,
	ChatBubbleHelpIcon: chatBubbleHelp,
	ChatBubbleHistoryIcon: chatBubbleHistory,
	ChatBubbleLockedIcon: chatBubbleLocked,
	ChatBubbleSmileIcon: chatBubbleSmile,
	ChatBubbleIcon: chatBubble,
	ChatCheckedIcon: chatChecked,
	ChatClearIcon: chatClear,
	ChatDoubleIcon: chatDouble,
	ChatErrorIcon: chatError,
	ChatHeartIcon: chatHeart,
	ChatMessageIcon: chatMessage,
	ChatOffIcon: chatOff,
	ChatPollIcon: chatPoll,
	ChatSettingIcon: chatSetting,
	ChatIcon: chat,
	CheckCircleFilledIcon: checkCircleFilled,
	CheckCircleIcon: checkCircle,
	CheckDoubleIcon: checkDouble,
	CheckRectangleFilledIcon: checkRectangleFilled,
	CheckRectangleIcon: checkRectangle,
	CheckIcon: check,
	CheeseIcon: cheese,
	CherryIcon: cherry,
	ChevronDownCircleIcon: chevronDownCircle,
	ChevronDownDoubleSIcon: chevronDownDoubleS,
	ChevronDownDoubleIcon: chevronDownDouble,
	ChevronDownRectangleIcon: chevronDownRectangle,
	ChevronDownSIcon: chevronDownS,
	ChevronDownIcon: chevronDown,
	ChevronLeftCircleIcon: chevronLeftCircle,
	ChevronLeftDoubleSIcon: chevronLeftDoubleS,
	ChevronLeftDoubleIcon: chevronLeftDouble,
	ChevronLeftRectangleIcon: chevronLeftRectangle,
	ChevronLeftSIcon: chevronLeftS,
	ChevronLeftIcon: chevronLeft,
	ChevronRightCircleIcon: chevronRightCircle,
	ChevronRightDoubleSIcon: chevronRightDoubleS,
	ChevronRightDoubleIcon: chevronRightDouble,
	ChevronRightRectangleIcon: chevronRightRectangle,
	ChevronRightSIcon: chevronRightS,
	ChevronRightIcon: chevronRight,
	ChevronUpCircleIcon: chevronUpCircle,
	ChevronUpDoubleSIcon: chevronUpDoubleS,
	ChevronUpDoubleIcon: chevronUpDouble,
	ChevronUpRectangleIcon: chevronUpRectangle,
	ChevronUpSIcon: chevronUpS,
	ChevronUpIcon: chevronUp,
	ChickenIcon: chicken,
	ChiliIcon: chili,
	Chimney1Icon: chimney1,
	Chimney2Icon: chimney2,
	ChimneyIcon: chimney,
	ChineseCabbageIcon: chineseCabbage,
	ChurchIcon: church,
	CircleIcon: circle,
	City1Icon: city1,
	City10Icon: city10,
	City11Icon: city11,
	City12Icon: city12,
	City13Icon: city13,
	City14Icon: city14,
	City15Icon: city15,
	City2Icon: city2,
	City3Icon: city3,
	City4Icon: city4,
	City5Icon: city5,
	City6Icon: city6,
	City7Icon: city7,
	City8Icon: city8,
	City9Icon: city9,
	CityAncient1Icon: cityAncient1,
	CityAncient2Icon: cityAncient2,
	CityAncientIcon: cityAncient,
	CityIcon: city,
	ClearFormatting1Icon: clearFormatting1,
	ClearFormattingIcon: clearFormatting,
	ClearIcon: clear,
	CloseCircleFilledIcon: closeCircleFilled,
	CloseCircleIcon: closeCircle,
	CloseOctagonIcon: closeOctagon,
	CloseRectangleIcon: closeRectangle,
	CloseIcon: close,
	CloudDownloadIcon: cloudDownload,
	CloudUploadIcon: cloudUpload,
	CloudIcon: cloud,
	CloudyDayIcon: cloudyDay,
	CloudyNightRainIcon: cloudyNightRain,
	CloudyNightIcon: cloudyNight,
	CloudyRainIcon: cloudyRain,
	CloudySunnyIcon: cloudySunny,
	Code1Icon: code1,
	CodeOffIcon: codeOff,
	CodeIcon: code,
	ColaIcon: cola,
	CollageIcon: collage,
	CollectionIcon: collection,
	ColorInvertIcon: colorInvert,
	CombinationIcon: combination,
	CommandIcon: command,
	Compass1Icon: compass1,
	CompassIcon: compass,
	ComponentBreadcrumbIcon: componentBreadcrumb,
	ComponentCheckboxIcon: componentCheckbox,
	ComponentDividerHorizontalIcon: componentDividerHorizontal,
	ComponentDividerVerticalIcon: componentDividerVertical,
	ComponentDropdownIcon: componentDropdown,
	ComponentGridIcon: componentGrid,
	ComponentInputIcon: componentInput,
	ComponentLayoutIcon: componentLayout,
	ComponentRadioIcon: componentRadio,
	ComponentSpaceIcon: componentSpace,
	ComponentStepsIcon: componentSteps,
	ComponentSwitchIcon: componentSwitch,
	ConstraintIcon: constraint,
	Contrast1Icon: contrast1,
	ContrastIcon: contrast,
	ControlPlatformIcon: controlPlatform,
	CooperateIcon: cooperate,
	CoordinateSystemIcon: coordinateSystem,
	CopyIcon: copy,
	CopyrightIcon: copyright,
	CornIcon: corn,
	CouponIcon: coupon,
	CourseIcon: course,
	CpuIcon: cpu,
	CrackIcon: crack,
	CreditcardAddIcon: creditcardAdd,
	CreditcardOffIcon: creditcardOff,
	CreditcardIcon: creditcard,
	CrookedSmileIcon: crookedSmile,
	CryAndLaughIcon: cryAndLaugh,
	CryLoudlyIcon: cryLoudly,
	Css3Icon: css3,
	CucumberIcon: cucumber,
	CurrencyExchangeIcon: currencyExchange,
	CursorIcon: cursor,
	CurtainIcon: curtain,
	CurveIcon: curve,
	Cut1Icon: cut1,
	CutIcon: cut,
	Dam1Icon: dam1,
	Dam2Icon: dam2,
	Dam3Icon: dam3,
	Dam4Icon: dam4,
	Dam5Icon: dam5,
	Dam6Icon: dam6,
	Dam7Icon: dam7,
	DamIcon: dam,
	DartBoardIcon: dartBoard,
	Dashboard1Icon: dashboard1,
	DashboardIcon: dashboard,
	DataBaseIcon: dataBase,
	DataCheckedIcon: dataChecked,
	DataDisplayIcon: dataDisplay,
	DataErrorIcon: dataError,
	DataSearchIcon: dataSearch,
	DataIcon: data,
	Delete1Icon: delete1,
	DeleteTimeIcon: deleteTime,
	DeleteIcon: _delete,
	DeltaIcon: delta,
	DepressedIcon: depressed,
	Desktop1Icon: desktop1,
	DesktopIcon: desktop,
	DespiseIcon: despise,
	DeviceIcon: device,
	DiscountFilledIcon: discountFilled,
	DiscountIcon: discount,
	DissatisfactionIcon: dissatisfaction,
	DivideIcon: divide,
	Dividers1Icon: dividers1,
	DividersIcon: dividers,
	DogeIcon: doge,
	DoubleStoreyIcon: doubleStorey,
	Download1Icon: download1,
	DownloadIcon: download,
	DownscaleIcon: downscale,
	DragDropIcon: dragDrop,
	DragMoveIcon: dragMove,
	DrinkIcon: drink,
	DrumstickIcon: drumstick,
	DvIcon: dv,
	DvdIcon: dvd,
	EarphoneIcon: earphone,
	EarthIcon: earth,
	Edit1Icon: edit1,
	Edit2Icon: edit2,
	EditOffIcon: editOff,
	EditIcon: edit,
	EducationIcon: education,
	EggplantIcon: eggplant,
	EllipsisIcon: ellipsis,
	EmoEmotionalIcon: emoEmotional,
	EnterIcon: enter,
	EqualIcon: equal,
	ErrorCircleFilledIcon: errorCircleFilled,
	ErrorCircleIcon: errorCircle,
	ErrorTriangleIcon: errorTriangle,
	ErrorIcon: error,
	Excited1Icon: excited1,
	ExcitedIcon: excited,
	ExpandHorizontalIcon: expandHorizontal,
	ExpandVerticalIcon: expandVertical,
	ExploreOffIcon: exploreOff,
	ExploreIcon: explore,
	ExposureIcon: exposure,
	ExtensionOffIcon: extensionOff,
	ExtensionIcon: extension,
	FaceRetouchingIcon: faceRetouching,
	FactCheckIcon: factCheck,
	FahrenheitScaleIcon: fahrenheitScale,
	FeelAtEaseIcon: feelAtEase,
	FerociousIcon: ferocious,
	FerrisWheelIcon: ferrisWheel,
	File1Icon: file1,
	FileAdd1Icon: fileAdd1,
	FileAddIcon: fileAdd,
	FileAttachmentIcon: fileAttachment,
	FileBlockedIcon: fileBlocked,
	FileCode1Icon: fileCode1,
	FileCodeIcon: fileCode,
	FileCopyIcon: fileCopy,
	FileDownloadIcon: fileDownload,
	FileExcelIcon: fileExcel,
	FileExportIcon: fileExport,
	FileIconIcon: fileIcon,
	FileImageIcon: fileImage,
	FileImportIcon: fileImport,
	FileLockedIcon: fileLocked,
	FileMinusIcon: fileMinus,
	FileMusicIcon: fileMusic,
	FileOnenoteIcon: fileOnenote,
	FileOutlookIcon: fileOutlook,
	FilePasteIcon: filePaste,
	FilePdfIcon: filePdf,
	FilePowerpointIcon: filePowerpoint,
	FileRestoreIcon: fileRestore,
	FileSafetyIcon: fileSafety,
	FileSearchIcon: fileSearch,
	FileSettingIcon: fileSetting,
	FileTeamsIcon: fileTeams,
	FileUnknownIcon: fileUnknown,
	FileUnlockedIcon: fileUnlocked,
	FileWordIcon: fileWord,
	FileZipIcon: fileZip,
	FileIcon: file,
	FillColor1Icon: fillColor1,
	FillColorIcon: fillColor,
	Film1Icon: film1,
	FilmIcon: film,
	Filter1Icon: filter1,
	Filter2Icon: filter2,
	Filter3Icon: filter3,
	FilterClearIcon: filterClear,
	FilterOffIcon: filterOff,
	FilterIcon: filter,
	Fingerprint1Icon: fingerprint1,
	Fingerprint2Icon: fingerprint2,
	Fingerprint3Icon: fingerprint3,
	FingerprintIcon: fingerprint,
	FishIcon: fish,
	Flag1Icon: flag1,
	Flag2Icon: flag2,
	Flag3Icon: flag3,
	Flag4Icon: flag4,
	FlagIcon: flag,
	FlashlightIcon: flashlight,
	FlightLandingIcon: flightLanding,
	FlightTakeoffIcon: flightTakeoff,
	FlipSmilingFaceIcon: flipSmilingFace,
	FlipToBackIcon: flipToBack,
	FlipToFrontIcon: flipToFront,
	FocusIcon: focus,
	FogNightIcon: fogNight,
	FogSunnyIcon: fogSunny,
	FogIcon: fog,
	Folder1Icon: folder1,
	FolderAdd1Icon: folderAdd1,
	FolderAddIcon: folderAdd,
	FolderBlockedIcon: folderBlocked,
	FolderDetailsIcon: folderDetails,
	FolderExportIcon: folderExport,
	FolderImportIcon: folderImport,
	FolderLockedIcon: folderLocked,
	FolderMinusIcon: folderMinus,
	FolderMoveIcon: folderMove,
	FolderOffIcon: folderOff,
	FolderOpen1Icon: folderOpen1,
	FolderOpenIcon: folderOpen,
	FolderSearchIcon: folderSearch,
	FolderSettingIcon: folderSetting,
	FolderSharedIcon: folderShared,
	FolderUnlockedIcon: folderUnlocked,
	FolderZipIcon: folderZip,
	FolderIcon: folder,
	ForestIcon: forest,
	ForkIcon: fork,
	FormIcon: form,
	FormatHorizontalAlignBottomIcon: formatHorizontalAlignBottom,
	FormatHorizontalAlignCenterIcon: formatHorizontalAlignCenter,
	FormatHorizontalAlignTopIcon: formatHorizontalAlignTop,
	FormatVerticalAlignCenterIcon: formatVerticalAlignCenter,
	FormatVerticalAlignLeftIcon: formatVerticalAlignLeft,
	FormatVerticalAlignRightIcon: formatVerticalAlignRight,
	ForwardIcon: forward,
	Frame1Icon: frame1,
	FrameIcon: frame,
	FriesIcon: fries,
	Fullscreen1Icon: fullscreen1,
	Fullscreen2Icon: fullscreen2,
	FullscreenExit1Icon: fullscreenExit1,
	FullscreenExitIcon: fullscreenExit,
	FullscreenIcon: fullscreen,
	FunctionCurveIcon: functionCurve,
	Functions1Icon: functions1,
	FunctionsIcon: functions,
	Gamepad1Icon: gamepad1,
	GamepadIcon: gamepad,
	GammaIcon: gamma,
	GarlicIcon: garlic,
	GenderFemaleIcon: genderFemale,
	GenderMaleIcon: genderMale,
	GestureApplauseIcon: gestureApplause,
	GestureClickIcon: gestureClick,
	GestureDownIcon: gestureDown,
	GestureExpansionIcon: gestureExpansion,
	GestureLeftSlipIcon: gestureLeftSlip,
	GestureLeftIcon: gestureLeft,
	GesturePray1Icon: gesturePray1,
	GesturePrayIcon: gesturePray,
	GesturePressIcon: gesturePress,
	GestureRanslation1Icon: gestureRanslation1,
	GestureRanslationIcon: gestureRanslation,
	GestureRightSlipIcon: gestureRightSlip,
	GestureRightIcon: gestureRight,
	GestureSlideUpIcon: gestureSlideUp,
	GestureUp1Icon: gestureUp1,
	GestureUp2Icon: gestureUp2,
	GestureUpAndDownIcon: gestureUpAndDown,
	GestureUpIcon: gestureUp,
	GestureWipeDownIcon: gestureWipeDown,
	GiftIcon: gift,
	GiggleIcon: giggle,
	GitBranchIcon: gitBranch,
	GitCommitIcon: gitCommit,
	GitMergeIcon: gitMerge,
	GitPullRequestIcon: gitPullRequest,
	GitRepositoryCommitsIcon: gitRepositoryCommits,
	GitRepositoryPrivateIcon: gitRepositoryPrivate,
	GitRepositoryIcon: gitRepository,
	GpsIcon: gps,
	GrapeIcon: grape,
	GreaterThanOrEqualIcon: greaterThanOrEqual,
	GreaterThanIcon: greaterThan,
	GreenOnionIcon: greenOnion,
	GridAddIcon: gridAdd,
	GridViewIcon: gridView,
	GuitarIcon: guitar,
	HamburgerIcon: hamburger,
	HappyIcon: happy,
	HardDiskStorageIcon: hardDiskStorage,
	HardDriveIcon: hardDrive,
	HashtagIcon: hashtag,
	HdIcon: hd,
	HeartFilledIcon: heartFilled,
	HeartIcon: heart,
	HelpCircleFilledIcon: helpCircleFilled,
	HelpCircleIcon: helpCircle,
	HelpRectangleIcon: helpRectangle,
	HelpIcon: help,
	Highlight1Icon: highlight1,
	HighlightIcon: highlight,
	HistorySettingIcon: historySetting,
	HistoryIcon: history,
	HomeIcon: home,
	Hospital1Icon: hospital1,
	HospitalIcon: hospital,
	HotspotWaveIcon: hotspotWave,
	HourglassIcon: hourglass,
	Houses1Icon: houses1,
	Houses2Icon: houses2,
	HousesIcon: houses,
	Html5Icon: html5,
	HttpsIcon: https,
	IceCreamIcon: iceCream,
	IconIcon: icon,
	Image1Icon: image1,
	ImageAddIcon: imageAdd,
	ImageEditIcon: imageEdit,
	ImageErrorIcon: imageError,
	ImageOffIcon: imageOff,
	ImageSearchIcon: imageSearch,
	ImageIcon: image,
	IndentLeftIcon: indentLeft,
	IndentRightIcon: indentRight,
	IndicatorIcon: indicator,
	InfoCircleFilledIcon: infoCircleFilled,
	InfoCircleIcon: infoCircle,
	InkIcon: ink,
	InstallDesktopIcon: installDesktop,
	InstallMobileIcon: installMobile,
	InstallIcon: install,
	InstitutionCheckedIcon: institutionChecked,
	InstitutionIcon: institution,
	InternetIcon: internet,
	IpodIcon: ipod,
	JoyfulIcon: joyful,
	JumpOffIcon: jumpOff,
	JumpIcon: jump,
	KeyboardIcon: keyboard,
	LaptopIcon: laptop,
	LayersIcon: layers,
	LayoutIcon: layout,
	LeaderboardIcon: leaderboard,
	LemonSliceIcon: lemonSlice,
	LemonIcon: lemon,
	LessThanOrEqualIcon: lessThanOrEqual,
	LessThanIcon: lessThan,
	LettersAIcon: lettersA,
	LettersBIcon: lettersB,
	LettersCIcon: lettersC,
	LettersDIcon: lettersD,
	LettersEIcon: lettersE,
	LettersFIcon: lettersF,
	LettersGIcon: lettersG,
	LettersHIcon: lettersH,
	LettersIIcon: lettersI,
	LettersJIcon: lettersJ,
	LettersKIcon: lettersK,
	LettersLIcon: lettersL,
	LettersMIcon: lettersM,
	LettersNIcon: lettersN,
	LettersOIcon: lettersO,
	LettersPIcon: lettersP,
	LettersQIcon: lettersQ,
	LettersRIcon: lettersR,
	LettersSIcon: lettersS,
	LettersTIcon: lettersT,
	LettersUIcon: lettersU,
	LettersVIcon: lettersV,
	LettersWIcon: lettersW,
	LettersXIcon: lettersX,
	LettersYIcon: lettersY,
	LettersZIcon: lettersZ,
	LightbulbCircleIcon: lightbulbCircle,
	LightbulbIcon: lightbulb,
	Lighthouse1Icon: lighthouse1,
	Lighthouse2Icon: lighthouse2,
	LighthouseIcon: lighthouse,
	LightingCircleIcon: lightingCircle,
	LineHeightIcon: lineHeight,
	Link1Icon: link1,
	LinkUnlinkIcon: linkUnlink,
	LinkIcon: link,
	LiquorIcon: liquor,
	ListNumberedIcon: listNumbered,
	ListIcon: list,
	LoadIcon: load,
	LoadingIcon: loading,
	Location1Icon: location1,
	LocationEnlargementIcon: locationEnlargement,
	LocationErrorIcon: locationError,
	LocationParkingPlaceIcon: locationParkingPlace,
	LocationReductionIcon: locationReduction,
	LocationSettingIcon: locationSetting,
	LocationIcon: location,
	LockOffFilledIcon: lockOffFilled,
	LockOffIcon: lockOff,
	LockOnFilledIcon: lockOnFilled,
	LockOnIcon: lockOn,
	LockTimeIcon: lockTime,
	LoginIcon: login,
	LogoAdobeIllustrateIcon: logoAdobeIllustrate,
	LogoAdobePhotoshop1Icon: logoAdobePhotoshop1,
	LogoAdobePhotoshopIcon: logoAdobePhotoshop,
	LogoAndroidIcon: logoAndroid,
	LogoAppleFilledIcon: logoAppleFilled,
	LogoAppleIcon: logoApple,
	LogoBehanceIcon: logoBehance,
	LogoChromeFilledIcon: logoChromeFilled,
	LogoChromeIcon: logoChrome,
	LogoCinema4DIcon: logoCinema4d,
	LogoCodepenIcon: logoCodepen,
	LogoCodesandboxIcon: logoCodesandbox,
	LogoDribbbleIcon: logoDribbble,
	LogoFacebookIcon: logoFacebook,
	LogoFigmaIcon: logoFigma,
	LogoFramerIcon: logoFramer,
	LogoGithubFilledIcon: logoGithubFilled,
	LogoGithubIcon: logoGithub,
	LogoGitlabIcon: logoGitlab,
	LogoIeFilledIcon: logoIeFilled,
	LogoIeIcon: logoIe,
	LogoInstagramIcon: logoInstagram,
	LogoQqIcon: logoQq,
	LogoTwitterIcon: logoTwitter,
	LogoWechatStrokeIcon: logoWechatStroke,
	LogoWechatIcon: logoWechat,
	LogoWecomIcon: logoWecom,
	LogoWindowsFilledIcon: logoWindowsFilled,
	LogoWindowsIcon: logoWindows,
	LogoYoutubeIcon: logoYoutube,
	LogoutIcon: logout,
	LookAroundIcon: lookAround,
	LoudspeakerIcon: loudspeaker,
	MailIcon: mail,
	Map3DIcon: map3d,
	MapAddIcon: mapAdd,
	MapAimingIcon: mapAiming,
	MapBlockedIcon: mapBlocked,
	MapBubbleIcon: mapBubble,
	MapCancelIcon: mapCancel,
	MapChatIcon: mapChat,
	MapCheckedIcon: mapChecked,
	MapCollectionIcon: mapCollection,
	MapConnectionIcon: mapConnection,
	MapDistanceIcon: mapDistance,
	MapDoubleIcon: mapDouble,
	MapEditIcon: mapEdit,
	MapGridIcon: mapGrid,
	MapInformation1Icon: mapInformation1,
	MapInformation2Icon: mapInformation2,
	MapInformationIcon: mapInformation,
	MapLocationIcon: mapLocation,
	MapLockedIcon: mapLocked,
	MapMarkedIcon: mapMarked,
	MapNavigationIcon: mapNavigation,
	MapOutlineIcon: mapOutline,
	MapRoutePlanningIcon: mapRoutePlanning,
	MapRulerIcon: mapRuler,
	MapSafetyIcon: mapSafety,
	MapSearch1Icon: mapSearch1,
	MapSearchIcon: mapSearch,
	MapSettingIcon: mapSetting,
	MapUnlockedIcon: mapUnlocked,
	MapIcon: map,
	MarkAsUnreadIcon: markAsUnread,
	MarkupIcon: markup,
	MathematicsIcon: mathematics,
	Measurement1Icon: measurement1,
	Measurement2Icon: measurement2,
	MeasurementIcon: measurement,
	MeatPepperIcon: meatPepper,
	MediaLibraryIcon: mediaLibrary,
	MemberIcon: member,
	MenuApplicationIcon: menuApplication,
	MenuFoldIcon: menuFold,
	MenuUnfoldIcon: menuUnfold,
	MenuIcon: menu,
	MergeCellsIcon: mergeCells,
	Microphone1Icon: microphone1,
	Microphone2Icon: microphone2,
	MicrophoneIcon: microphone,
	MilkIcon: milk,
	MinusCircleFilledIcon: minusCircleFilled,
	MinusCircleIcon: minusCircle,
	MinusRectangleFilledIcon: minusRectangleFilled,
	MinusRectangleIcon: minusRectangle,
	MinusIcon: minus,
	MirrorIcon: mirror,
	MobileBlockedIcon: mobileBlocked,
	MobileListIcon: mobileList,
	MobileNavigationIcon: mobileNavigation,
	MobileShortcutIcon: mobileShortcut,
	MobileVibrateIcon: mobileVibrate,
	MobileIcon: mobile,
	ModeDarkIcon: modeDark,
	ModeLightIcon: modeLight,
	ModuleIcon: module,
	MoneyIcon: money,
	MonumentIcon: monument,
	MoonFallIcon: moonFall,
	MoonRisingIcon: moonRising,
	MoonIcon: moon,
	MoreIcon: more,
	Mosque1Icon: mosque1,
	MosqueIcon: mosque,
	MouseIcon: mouse,
	Move1Icon: move1,
	MoveIcon: move,
	MovieClapperIcon: movieClapper,
	MultiplyIcon: multiply,
	Museum1Icon: museum1,
	Museum2Icon: museum2,
	MuseumIcon: museum,
	Mushroom1Icon: mushroom1,
	MushroomIcon: mushroom,
	Music1Icon: music1,
	Music2Icon: music2,
	MusicRectangleAddIcon: musicRectangleAdd,
	MusicIcon: music,
	NavigationArrowIcon: navigationArrow,
	NextIcon: next,
	NoExpressionIcon: noExpression,
	NoodleIcon: noodle,
	NotificationAddIcon: notificationAdd,
	NotificationCircleIcon: notificationCircle,
	NotificationErrorIcon: notificationError,
	NotificationFilledIcon: notificationFilled,
	NotificationIcon: notification,
	Numbers01Icon: numbers01,
	Numbers0Icon: numbers0,
	Numbers11Icon: numbers11,
	Numbers1Icon: numbers1,
	Numbers21Icon: numbers21,
	Numbers2Icon: numbers2,
	Numbers31Icon: numbers31,
	Numbers3Icon: numbers3,
	Numbers41Icon: numbers41,
	Numbers4Icon: numbers4,
	Numbers51Icon: numbers51,
	Numbers5Icon: numbers5,
	Numbers61Icon: numbers61,
	Numbers6Icon: numbers6,
	Numbers71Icon: numbers71,
	Numbers7Icon: numbers7,
	Numbers81Icon: numbers81,
	Numbers8Icon: numbers8,
	Numbers91Icon: numbers91,
	Numbers9Icon: numbers9,
	NutIcon: nut,
	ObjectStorageIcon: objectStorage,
	OpenMouthIcon: openMouth,
	OperaIcon: opera,
	OrderAdjustmentColumnIcon: orderAdjustmentColumn,
	OrderAscendingIcon: orderAscending,
	OrderDescendingIcon: orderDescending,
	OutboxIcon: outbox,
	PageFirstIcon: pageFirst,
	PageHeadIcon: pageHead,
	PageLastIcon: pageLast,
	Palace1Icon: palace1,
	Palace2Icon: palace2,
	Palace3Icon: palace3,
	Palace4Icon: palace4,
	PalaceIcon: palace,
	Palette1Icon: palette1,
	PaletteIcon: palette,
	PanoramaHorizontalIcon: panoramaHorizontal,
	PanoramaVerticalIcon: panoramaVertical,
	PantoneIcon: pantone,
	ParabolaIcon: parabola,
	ParenthesesIcon: parentheses,
	PasteIcon: paste,
	PatioIcon: patio,
	PauseCircleFilledIcon: pauseCircleFilled,
	PauseCircleStrokeIcon: pauseCircleStroke,
	PauseCircleIcon: pauseCircle,
	PauseIcon: pause,
	PeaIcon: pea,
	PeachIcon: peach,
	PearIcon: pear,
	PearlOfTheOrientIcon: pearlOfTheOrient,
	PenBallIcon: penBall,
	PenBrushIcon: penBrush,
	PenMarkIcon: penMark,
	PenQuillIcon: penQuill,
	PenIcon: pen,
	PendingIcon: pending,
	PercentIcon: percent,
	PersonalInformationIcon: personalInformation,
	PhoneLockedIcon: phoneLocked,
	PhoneSearchIcon: phoneSearch,
	PiIcon: pi,
	PianoIcon: piano,
	PinFilledIcon: pinFilled,
	PinIcon: pin,
	PlayCircleFilledIcon: playCircleFilled,
	PlayCircleStrokeAddIcon: playCircleStrokeAdd,
	PlayCircleStrokeIcon: playCircleStroke,
	PlayCircleIcon: playCircle,
	PlayDemoIcon: playDemo,
	PlayRectangleIcon: playRectangle,
	PlayIcon: play,
	PlusIcon: plus,
	PopsicleIcon: popsicle,
	PortraitIcon: portrait,
	PoutIcon: pout,
	PoweroffIcon: poweroff,
	PreciseMonitorIcon: preciseMonitor,
	PreviousIcon: previous,
	PrintIcon: print,
	PumpkinIcon: pumpkin,
	PyramidMayaIcon: pyramidMaya,
	PyramidIcon: pyramid,
	QrcodeIcon: qrcode,
	QuadraticIcon: quadratic,
	QuestionnaireIcon: questionnaire,
	QueueIcon: queue,
	RadarIcon: radar,
	Radio1Icon: radio1,
	Radio2Icon: radio2,
	RadishIcon: radish,
	RainHeavyIcon: rainHeavy,
	RainLightIcon: rainLight,
	RainMediumIcon: rainMedium,
	RainbowIcon: rainbow,
	RectangleIcon: rectangle,
	RefreshIcon: refresh,
	RelationIcon: relation,
	RelativityIcon: relativity,
	RemoteWaveIcon: remoteWave,
	RemoveIcon: remove,
	ReplayIcon: replay,
	RiceBallIcon: riceBall,
	RiceIcon: rice,
	RoastIcon: roast,
	RocketIcon: rocket,
	RollbackIcon: rollback,
	RollfrontIcon: rollfront,
	RootListIcon: rootList,
	RotateLockedIcon: rotateLocked,
	RotateIcon: rotate,
	RotationIcon: rotation,
	RoundIcon: round,
	RouterWaveIcon: routerWave,
	RssIcon: rss,
	RulerIcon: ruler,
	SailingHotelIcon: sailingHotel,
	SandwichIcon: sandwich,
	SaturationIcon: saturation,
	SausageIcon: sausage,
	SaveIcon: save,
	SavingPotIcon: savingPot,
	ScanIcon: scan,
	Screen4KIcon: screen4k,
	ScreencastIcon: screencast,
	ScreenshotIcon: screenshot,
	ScrollBarIcon: scrollBar,
	SdCard1Icon: sdCard1,
	SdCardIcon: sdCard,
	SearchErrorIcon: searchError,
	SearchIcon: search,
	SecuredIcon: secured,
	SendCancelIcon: sendCancel,
	SendIcon: send,
	Sensors1Icon: sensors1,
	Sensors2Icon: sensors2,
	SensorsOffIcon: sensorsOff,
	SensorsIcon: sensors,
	SerenityIcon: serenity,
	ServerIcon: server,
	ServiceIcon: service,
	Setting1Icon: setting1,
	SettingIcon: setting,
	Share1Icon: share1,
	ShareIcon: share,
	SharpnessIcon: sharpness,
	ShieldErrorIcon: shieldError,
	ShimenIcon: shimen,
	Shop1Icon: shop1,
	Shop2Icon: shop2,
	Shop3Icon: shop3,
	Shop4Icon: shop4,
	Shop5Icon: shop5,
	ShopIcon: shop,
	ShrimpIcon: shrimp,
	ShrinkHorizontalIcon: shrinkHorizontal,
	ShrinkVerticalIcon: shrinkVertical,
	ShutterIcon: shutter,
	ShutupIcon: shutup,
	SimCard1Icon: simCard1,
	SimCard2Icon: simCard2,
	SimCardIcon: simCard,
	SinisterSmileIcon: sinisterSmile,
	SipIcon: sip,
	SlashIcon: slash,
	SleepIcon: sleep,
	SliceIcon: slice,
	SlideshowIcon: slideshow,
	SmileIcon: smile,
	SneerIcon: sneer,
	SnowflakeIcon: snowflake,
	SonicIcon: sonic,
	SoundDownIcon: soundDown,
	SoundHighIcon: soundHigh,
	SoundLowIcon: soundLow,
	SoundMute1Icon: soundMute1,
	SoundMuteIcon: soundMute,
	SoundUpIcon: soundUp,
	SoundIcon: sound,
	SpaceIcon: space,
	Speechless1Icon: speechless1,
	StarFilledIcon: starFilled,
	StarIcon: star,
	StatueOfJesusIcon: statueOfJesus,
	StickyNoteIcon: stickyNote,
	StopCircleFilledIcon: stopCircleFilled,
	StopCircleStrokeIcon: stopCircleStroke,
	StopCircleIcon: stopCircle,
	StopIcon: stop,
	StoreIcon: store,
	StreetRoad1Icon: streetRoad1,
	StreetRoadIcon: streetRoad,
	SubtitleIcon: subtitle,
	SubwayLineIcon: subwayLine,
	SumIcon: sum,
	SunFallIcon: sunFall,
	SunRisingIcon: sunRising,
	SunnyIcon: sunny,
	SupportIcon: support,
	Surprised1Icon: surprised1,
	SurprisedIcon: surprised,
	SwapLeftIcon: swapLeft,
	SwapRightIcon: swapRight,
	SwapIcon: swap,
	Swear1Icon: swear1,
	Swear2Icon: swear2,
	System2Icon: system2,
	System3Icon: system3,
	SystemApplicationIcon: systemApplication,
	SystemBlockedIcon: systemBlocked,
	SystemCodeIcon: systemCode,
	SystemComponentsIcon: systemComponents,
	SystemCoordinateIcon: systemCoordinate,
	SystemDeviceIcon: systemDevice,
	SystemInterfaceIcon: systemInterface,
	SystemLocationIcon: systemLocation,
	SystemLockedIcon: systemLocked,
	SystemLogIcon: systemLog,
	SystemMarkedIcon: systemMarked,
	SystemMessagesIcon: systemMessages,
	SystemRegulationIcon: systemRegulation,
	SystemSearchIcon: systemSearch,
	SystemSettingIcon: systemSetting,
	SystemStorageIcon: systemStorage,
	SystemSumIcon: systemSum,
	SystemUnlockedIcon: systemUnlocked,
	TabIcon: tab,
	Table1Icon: table1,
	Table2Icon: table2,
	TableAddIcon: tableAdd,
	TableSplitIcon: tableSplit,
	TableIcon: table,
	TagIcon: tag,
	TangerinrIcon: tangerinr,
	TapeIcon: tape,
	Task1Icon: task1,
	TaskAdd1Icon: taskAdd1,
	TaskAddIcon: taskAdd,
	TaskCheckedIcon: taskChecked,
	TaskErrorIcon: taskError,
	TaskLocationIcon: taskLocation,
	TaskMarkedIcon: taskMarked,
	TaskSettingIcon: taskSetting,
	TaskVisibleIcon: taskVisible,
	TaskIcon: task,
	TeaIcon: tea,
	TeahouseIcon: teahouse,
	TemplateIcon: template,
	TempleIcon: temple,
	TerminalRectangle1Icon: terminalRectangle1,
	TerminalRectangleIcon: terminalRectangle,
	TerminalWindowIcon: terminalWindow,
	TerminalIcon: terminal,
	TextboxIcon: textbox,
	TextformatBoldIcon: textformatBold,
	TextformatColorIcon: textformatColor,
	TextformatItalicIcon: textformatItalic,
	TextformatStrikethroughIcon: textformatStrikethrough,
	TextformatUnderlineIcon: textformatUnderline,
	TextformatWrapIcon: textformatWrap,
	TheatersIcon: theaters,
	ThumbDown1Icon: thumbDown1,
	ThumbDown2Icon: thumbDown2,
	ThumbDownIcon: thumbDown,
	ThumbUp1Icon: thumbUp1,
	ThumbUp2Icon: thumbUp2,
	ThumbUpIcon: thumbUp,
	ThunderIcon: thunder,
	ThunderstormNightIcon: thunderstormNight,
	ThunderstormSunnyIcon: thunderstormSunny,
	ThunderstormIcon: thunderstorm,
	TicketIcon: ticket,
	TimeFilledIcon: timeFilled,
	TimeIcon: time,
	TipsDoubleIcon: tipsDouble,
	TipsIcon: tips,
	TomatoIcon: tomato,
	ToolsCircleIcon: toolsCircle,
	ToolsIcon: tools,
	TornadoIcon: tornado,
	Tower1Icon: tower1,
	Tower2Icon: tower2,
	Tower3Icon: tower3,
	TowerClockIcon: towerClock,
	TowerIcon: tower,
	TownIcon: town,
	TrafficEventsIcon: trafficEvents,
	TrafficIcon: traffic,
	Transform1Icon: transform1,
	Transform2Icon: transform2,
	Transform3Icon: transform3,
	TransformIcon: transform,
	Translate1Icon: translate1,
	TranslateIcon: translate,
	TreeListIcon: treeList,
	TreeRoundDotVerticalIcon: treeRoundDotVertical,
	TreeRoundDotIcon: treeRoundDot,
	TreeSquareDotVerticalIcon: treeSquareDotVertical,
	TreeSquareDotIcon: treeSquareDot,
	TrendingDownIcon: trendingDown,
	TrendingUpIcon: trendingUp,
	Tv1Icon: tv1,
	Tv2Icon: tv2,
	TvIcon: tv,
	TypographyIcon: typography,
	Uncomfortable1Icon: uncomfortable1,
	Uncomfortable2Icon: uncomfortable2,
	UncomfortableIcon: uncomfortable,
	UndertakeDeliveryIcon: undertakeDelivery,
	UndertakeEnvironmentProtectionIcon: undertakeEnvironmentProtection,
	UndertakeHoldUpIcon: undertakeHoldUp,
	UndertakeTransactionIcon: undertakeTransaction,
	UndertakeIcon: undertake,
	UnfoldLessIcon: unfoldLess,
	UnfoldMoreIcon: unfoldMore,
	Unhappy1Icon: unhappy1,
	UnhappyIcon: unhappy,
	UninstallIcon: uninstall,
	Upload1Icon: upload1,
	UploadIcon: upload,
	UpscaleIcon: upscale,
	UsbIcon: usb,
	User1Icon: user1,
	UserAddIcon: userAdd,
	UserArrowDownIcon: userArrowDown,
	UserArrowLeftIcon: userArrowLeft,
	UserArrowRightIcon: userArrowRight,
	UserArrowUpIcon: userArrowUp,
	UserAvatarIcon: userAvatar,
	UserBlockedIcon: userBlocked,
	UserBusinessIcon: userBusiness,
	UserChecked1Icon: userChecked1,
	UserCheckedIcon: userChecked,
	UserCircleIcon: userCircle,
	UserClearIcon: userClear,
	UserError1Icon: userError1,
	UserInvisibleIcon: userInvisible,
	UserListIcon: userList,
	UserLockedIcon: userLocked,
	UserMarkedIcon: userMarked,
	UserPasswordIcon: userPassword,
	UserSafetyIcon: userSafety,
	UserSearchIcon: userSearch,
	UserSettingIcon: userSetting,
	UserTalk1Icon: userTalk1,
	UserTalkOff1Icon: userTalkOff1,
	UserTalkIcon: userTalk,
	UserTimeIcon: userTime,
	UserTransmitIcon: userTransmit,
	UserUnknownIcon: userUnknown,
	UserUnlockedIcon: userUnlocked,
	UserVipIcon: userVip,
	UserVisibleIcon: userVisible,
	UserIcon: user,
	UsergroupAddIcon: usergroupAdd,
	UsergroupClearIcon: usergroupClear,
	UsergroupIcon: usergroup,
	VehicleIcon: vehicle,
	VerifiedIcon: verified,
	VerifyIcon: verify,
	VideoCamera1Icon: videoCamera1,
	VideoCamera2Icon: videoCamera2,
	VideoCameraDollarIcon: videoCameraDollar,
	VideoCameraMinusIcon: videoCameraMinus,
	VideoCameraMusicIcon: videoCameraMusic,
	VideoCameraOffIcon: videoCameraOff,
	VideoCameraIcon: videoCamera,
	VideoLibraryIcon: videoLibrary,
	VideoIcon: video,
	ViewAgendaIcon: viewAgenda,
	ViewColumnIcon: viewColumn,
	ViewInArIcon: viewInAr,
	ViewListIcon: viewList,
	ViewModuleIcon: viewModule,
	VisualRecognitionIcon: visualRecognition,
	WalletIcon: wallet,
	WatchIcon: watch,
	WatermelonIcon: watermelon,
	WaveLeftIcon: waveLeft,
	WaveRightIcon: waveRight,
	Wealth1Icon: wealth1,
	WealthIcon: wealth,
	WidgetIcon: widget,
	Wifi1Icon: wifi1,
	WifiOff1Icon: wifiOff1,
	WifiOffIcon: wifiOff,
	WifiIcon: wifi,
	Window1Icon: window1,
	WindowIcon: window,
	WindyRainIcon: windyRain,
	WindyIcon: windy,
	WinkIcon: wink,
	WorkHistoryIcon: workHistory,
	WorkOffIcon: workOff,
	WorkIcon: work,
	WrySmileIcon: wrySmile,
	ZoomInIcon: zoomIn,
	ZoomOutIcon: zoomOut
});

export { icons as i };
//# sourceMappingURL=dep-f9200710.js.map
